//二级页面内容
const projects = [
  {
    img_count: 3, //轮播图的数量
    areaId: "jinjiang", //区域的id
    desc: `<p>锦江区地处成都市主城区东南部，1991 年建区，因濯锦之江而得名，幅员面积 62 平方公里，辖 11 个街道 76 个社区，户籍人口 61.7 万，常住人口 115.9 万，是全国商贸繁华区、全国文化先进区、全国社区治理和服务创新实验区、国家级生态区、全国平安建设先进区。</p>
    <h4>2019年</h4>
    <p>
      实现 GDP1122.2 亿元<br/>
      增长 7.2%<br/>
      服务业增加值 994.5 亿元<br/>
      增长 7.0%
    </p>
    <p>
      固定资产投资 375.07 亿元<br/>
      增长 9.4%<br/>
      社消零总额 1144 亿元<br/>
      增长 9.7%
    </p>
    <p>
      一般公共预算收入 88.17 亿元<br/>
      区级税收收入 66.33 亿元<br/>
      城镇居民人均可支配收入48595元。<br/>
    </p>
    <h4>人文</h4>
    <p>锦江区历史悠久、人文荟萃，自秦始即为成都县地，自唐代起便以“百业云集，市廛兴盛”饮誉巴蜀“首善之区”，是中国西部“洋务”和“兴商”发祥地，拥有大慈寺、江南馆、水井坊等 30 多处历史遗存，诞生了世界上最早的纸币“交子”，李白、杜甫等文人墨客为锦江留下灿烂诗篇，是彰显天府文化的重要窗口。</p>
    <h4>商业</h4>
    <p>锦江区商业优势全国领先，商务配套高端完善，春熙路商圈驰名中外，拥有 IFS、太古里等高端商业载体 25 个，聚集国际品牌 659 个，各类首店入驻西部地区锦江区商业优势全国领先，商务配套高端完善，春熙路商圈驰名中外，拥有 IFS、太古里等
    高端商业载体 25 个，聚集国际品牌 659 个，各类首店入驻西部地区占比最高。国际资源和先进生产要素富集，聚集“世界 500 强”136 家，总部型企业 350 家，外国驻蓉领事机构 10 家、签证中心 12 个，麦肯锡等世界顶级服务机构 12 家，成都市 70% 的外资金融机构。在全
    省率先推行“仅跑一次”放管服改革，获评“中国最佳国际营商环境城区”。推门就是美好生活，绿化覆盖率达 45.2%，拥有三圣花乡等国家级旅游品牌13 个，优质教育全市领先、公共服务配套完善、医疗康养优势突出，是成都高品质和谐宜居生活城区典范。</p>
    <h4>定位</h4>
    <p>锦江区正抢抓成渝地区双城经济圈建设重大战略机遇，以建设践行新发展理念的公园城市示范区为统揽，坚定落实市委“中优”战略，突出“天府成都·品位锦江”形象定位，做强商业商务中心、国际时尚标杆、天府文化窗口、品质生活典范功能支撑，奋力打造更加美丽、更具活力、更有品位的现代化国际化锦江。
    锦江区以“五大行动”为抓手，加快构建区域发展新格局。实施产业升级行动，加快建设春熙路时尚活力区、白鹭湾新经济总部功能区、锦江新兴传媒功能区，大力发展楼宇经济、生活性服务业、生产性服务业、都市工业和新经济，全力构建开放型现代化产业体系。实施消费引领行动，全力
    建设春熙路—盐市口、交子公园、攀成钢、东村四大商圈，大力发展首店经济、网红经济、小店经济、后街经济、夜间经济等，加快建设国际消费中心城市引领区。实施场景营造行动，全力营造高品质生态生产生活和机会场景，推动城市形态重塑、全域旅游发展、天府文化传承，让推门就是
    美好生活成为锦江最靓丽的名片。实施开放合作行动，提升全球资源配置能力，打造国际化营商环境，持续提升区域国际化水平。实施治理提能行动，构建风险防控体系、城市运行保障体系、社会治理体系、公共服务体系和社区生活服务体系，不断增强人民群众获得感幸福感安全感。</p>`,
    popup: {
      title: "锦江区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/1/jinjiang.png" class="bimg" />
      <p>一 . 新引进的境外世界 500 强法人机构，经认定，给予最高不超过 150 万元的开办发展奖励。新引进的知名企业设立的法人机构、境外世界 500 强独立核算的分支机构，经认定，给予最高不超过 100 万元的开办发展奖励。新引进的其他法人机构，自注册之日起一年内实际
      到位市外资金 1 亿元 ( 含 ) 或 FDI 达 1000万美元 ( 含 ) 以上，经认定，给予最高不超过 100 万元的开办发展奖励。</p>
      <p>二 . 新引进的境外世界 500 强、知名企业总部、其他企业总部租用办公用房 ( 不含对外营业用房 )，经认定，5 年内以其年度区级经济实际贡献度为参照数，分别按最高不超过 80 元 / 月·平方米、60 元 / 月·平方米、40 元 / 月·平方米的标准，在 1000 平方米内据实给
      予租房补贴 ; 在我区购置自用办公用房 ( 不含对外营业用房 )，按不超过购房总价的 10%，给予最高不超过 500 万元的购房补贴。</p>
      <p>三 . 新引进的总部企业，经认定，5 年内分别按最高不超过年度区级经济实际贡献度的 80%、80%、80%、70%、70% 给予政策扶持。区内存量企业自达我区总部企业标准之日起，经认定，5 年内按照新引进总部企业的扶持标准给予用房支持和贡献支持。</p>
      <p>四 . 国家旅游主管部门新认定的五星级、四星级、三星级乡村民宿，以其年度区级经济实际贡献度为参照数，分别给予最高不超过 30 万元、20 万元、10 万元的奖励。市级旅游主管部门新认定或授牌的五星级农家乐、精品乡村民宿，以其年度区级经济实际贡献度为参照数，分别
      给予最高不超过 5 万元、10 万元的奖励。</p>
      <p>五 . 新引进中国饭店集团 60 强、全国 100 强旅行社在我区设立区域总部，以其年度区级经济实际贡献度为参照数，经认定，分别给予最高不超过 30 万元、10 万元的开办补贴。</p>
      <p>六 . 符合我区产业发展方向的新办企业，扶持期满后第二个年度起，以其年度区级经济实际贡献度为参照数，达 300 万元 ( 文化创意企业达 60 万元，新经济企业和金融企业达 100 万元 ) 且较上年度增幅10% 以上的，经认定，按不超过其较上年度增长部分的 60% 给予政策扶持。</p>
      <p>七 . 首次达到并纳入“四上”统计库企业 ( 工业、建筑业企业除外 )，经认定，一次性给予 5 万元的奖励 ;纳入“四上”且年销售额同比增幅超过区级年度社会消费品零售总额增幅的商贸零售企业，经认定，按实现年销售额 1( 含 )-2 亿元、2( 含 )-5 亿元、5 亿元 ( 含 )以
      上三个档次，分别给予企业 2 万元、5 万元、10 万元的奖励 ; 纳入“四上”且年营业额同比增幅超过全市规模以上营利性服务业营业收入增幅的规上营利性服务业企业，经认定，按实现年营业额 2000( 含 )-3000 万 元、3000( 含 )-5000 万 元、5000 万 元 ( 含 )以上三个档
      次，分别给予企业 2 万元、5 万元、10 万元的奖励，其中，年营业额排名前 5 位的规上营利性服务业企业，可再给予 5 万元的奖励。</p>
      <p>八 . 未享受地方贡献扶持政策的重点企业，年度区级经济实际贡献度达 500 万元以上的，按最高不超过企业年度区级经济实际贡献度的 5% 给予企业高管奖励 ; 对商务服务企业集中汇缴的个人年度经济实际贡献达到 100 万元以上的，经认定，对不超过 5 名企业高管人员，
      按其个人年度区级经济实际贡献度的100% 给予奖励，以后每增长 100 万元，增加不超过5 名企业高管人员的奖励，单个企业累计最高不超过20 人 ; 对符合享受区级经济实际贡献政策扶持条件的重点新办企业和存量企业，经认定，可将不超过 50%的企业扶持资金用于经营团队奖
      励 ; 金融企业高管或高级人才年薪达 100 万元以上的，按其个人年度区级经济实际贡献度的 100% 给予奖励，单个企业累计最高不超过 10 人。</p>
      <p>九 . 实施“产业人才新政”，赋予企业人才自主评价权，对年度区级经济实际作出较大贡献的产业人才，授予“产业杰出贡献人才”“产业突出贡献人才”“产业优秀人才”荣誉称号，分别给予最高不超过 120 万元、80 万元、30 万元的奖励。</p>
      <p>十 . 实施“锦绣优才”培养计划，遴选培养一批具有领军潜能、创新潜力的本土人才，给予每人 20 万元的奖励。设立“锦城伯乐”招才引智奖，对引进培育高层次创新创业人才的“锦城伯乐”给予最高 20 万元引才奖励和最高 10 万元育才奖励，对所引进人才带项目、带资金到锦江
      区创办企业、注册资本在 500 万元以上的 ( 以实际到位资金为准 )，额外给予“锦城伯乐”最高 50 万元的协同引才奖励。</p>
      <p>十一 . 分层分类为各类高层次人才提供安家落户、购房、子女入学、创新创业扶持等方面的优质服务。完善人才安居体系，对急需紧缺人才提供人才公寓租赁服务，给予最高 5 年、120 平方米人才公寓的租金补贴，租住满 5 年后可申请按入住时市场价格购买。住房限购期间，对
      于重大招商引资项目引进的高端人才，经认定，其购房不受户籍、社保缴纳时间的限制。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "环球汇广场",
        contact: "杨嘉林",
        phone: "156-8045-5566 ",
        img_count: 2,
        desc: `<h4 class="title">环球汇广场</h4>
        <h4>建设地点</h4>
        <p>成都市锦江区东大路</p>
        <h4>建设工期</h4>
        <p>2010年12月-2023年8月</p>
        <h4>投资总额</h4>
        <p>109.78亿元</p>
        <h4>建设内容</h4>
        <p>总建筑面积125万平方米<br/>商业面积16万平方米<br/>写字楼面积31.6万平方米<br/>酒店面积3.3万平方米<br/>住宅面积44万平方米<br/>其他面积30.1万平方米<br/>最高建筑高度200米</p>
        <h4>建设条件</h4>
        <p>酒店面积 3.3 万平方米<br/>交付使用或自装可商议</p>
        <h4>合作方式</h4>
        <p>招租</p>
        <h4>联系方式</h4>
        <p>杨嘉林（156-8045-5566）</p>`,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "锦江文化创意产业中心（一期）项目",
        contact: "",
        phone: "8592-3531转2118",
        img_count: 3,
        desc: `<h4 class="title">江文化创意产业中心（一期）项目</h4>
        <h4>建设地点</h4>
        <p>商业服务业设施用地，容积率小于等于 6.0，总建筑密度小于等于 45%。建筑物最高点高程不大于航空限高绝对还把高程 798 米。</p>
        <h4>建设工期</h4>
        <p>2018.4 至 2023.12。</p>
        <h4>投资总额</h4>
        <p>18 亿元</p>
        <h4>建设内容</h4>
        <p>建设总建筑面积约 24.6 万平方米的商业综合体，含 4 栋塔楼及 3 层裙房商业。业态规划如下：</p>
        <img src="./images/area/1/jian.png" class="jimg" />
        <h4>建设条件</h4>
        <p>商业服务业设施用地，容积率小于等于 6.0，总建筑密度小于等于 45%。建筑物最高点高程不大于航空限高绝对还把高程 798 米。</p>
        <h4>合作方式</h4>
        <p>酒店品牌及运营合作。</p>
        <h4>联系电话</h4>
        <p>8592-3531转2118</p>
        <h4>附：酒店规划情况——五星商务会议型酒店</h4>
        <p>建筑面积：建筑面积 33833.9 平方米。<br/>
           策划定位：城东奢华酒店标杆、三圣高端商务配套。<br/>
           策划功能：商务会议、优质配套、定制服务。<br/>
           策划亮点：新型会议系统、高空休闲娱乐、国际酒店管理。<br/>
           发展目标：国际顶尖酒店品牌，区域商务酒店新典范。<br/>
           市场站位：以商务会议为核心，拓展 MICE 服务体系，完善周边产业配套。<br/>
           客群定位：商务客群、医院高端客群。</p>`,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "滨江路5号地块",
        contact: "徐钊",
        phone: "13881984494",
        img_count: 2,
        desc: `<h4 class="title">滨江路5号地块</h4>
                <h4>建设地点</h4>
				<p>滨江路与人民南路交界处</p>
				<h4>建设工期</h4>
				<p>待定（36个月以内）</p>
				<h4>投资总额</h4>
				<p>待定</p>
				<h4>建设内容</h4>
				<p>该地块为商业服务业设施用地（可建酒店项目），公共配套设施包括：公园绿地、地下停车场（库）、市政设施用房、停车泊位充电设施。</p>
        <h4>建设条件</h4>
        <p>项目占地面积共计 15.54 亩，容积率为小于等于 8.0，建筑高度不大于 169 米。</p>
        <h4>合作方式</h4>
        <p>出售地块</p>
        <h4>联系方式</h4>
        <p>徐钊 13881984494</p>`,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "成都市锦江区 花卉市场项目",
        contact: "冯珂",
        phone: "18113027005",
        img_count: 3,
        desc: `<h4 class="title">成都市锦江区 花卉市场项目</h4>
        <h4>建设地点</h4>
        <p>锦江区三圣街道，成龙大道一段，成龙立交西侧</p>
        <h4>建设工期</h4>
        <p>2020年12月-2023年12月</p>
        <h4>投资总额</h4>
        <p>135400万元</p>
        <h4>建设内容</h4>
        <p>建成以鲜切花、盆栽花、花资花肥批零交易为主，展览教育、主题酒店、娱乐休闲、特色餐饮等为辅的都市现代花卉主题休闲度假综合体，建设成为成都最大的花卉展示展销中心、花木批发商务交易中心，以及以花木为主题的都市消费中心。</p>
        <h4>建设条件</h4>
        <p>项目占地面积共计约 74 亩（1 号宗地约 36 亩，2 号宗地约 37 亩），容积率为 2.0，根据产业策划定位报告建议，1 号地块定位为花卉主题商业街区，计划引入酒店、精品花店、餐饮、轻食、亲子等业态。计划酒店面积约 1.8 万平方米，其中宴会厅约 3 千至 6 千平方米、预计客房约 200 至 250 间。</p>
        <h4>合作方式</h4>
        <p>租赁</p>
        <h4>联系方式</h4>
        <p>冯珂 18113027005</p>`,
      },
    ],
  },
  {
    img_count: 3, //轮播图的数量
    areaId: "tianfu", //区域的id
    desc: `四川天府新区是 2014 年 10 月 2 日由国务院批复设立的第 11 个国家级新区，规划面积 1578 平方公里，其中，成都直管区面积 564 平方公里，是国家实施新一轮西部大开发战略的重要支撑。<br/>2018 年 2 月 11 日，习近平总书记视察天府新区指出，“天府新区是’一带一路’建设和长江经济带发展
    的重要节点，一定要规划好建设好，特别是要突出公园城市特点，把生态价值考虑进去，努力打造新的增长极，建设内陆开放经济高地”，为天府新区明确了战略定位、标定了城市特质、规划了奋斗目标、指引了发展方向。四川省委省政府将天府新区定位为“百年大计，省之大事”。<br/>天府新区遵循习近平总书记重要指
    示精神，认真落实省委省政府决策部署，保持战略定力、久久为功，全力推进“二次创业”，正加快打造新时代公园城市典范和国家级新区高质量发展样板。`,
    popup: {
      title: "成都天府新区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/2/tianfu.png" class="bimg" />
      <p>在新区范围内于 2019 年 12 月底之前新建成投运的酒店项目，五星级酒店项目或装修标准达 6000 元 / 平方米（含）以上的酒店按 2 万元/ 间客房给予奖励，星级酒店或装修标准达 3000元 / 平方米（含）以上且低于 6000 元 / 平方米的酒店按 1 万元 / 间客房给予奖励。<br/>在新区范围内新开工
      （以取得主体部分《建筑工程施工许可证》的时间为准，综合体项目仅计入酒店部分），且承诺在《国有建设用地使用权出让合同》约定的时间内建设竣工投产的酒店项目，出具书面承诺并经产业部门审核后，缓交酒店部分面积的特大城市市政基础设施配套费直管区留存部分（以下简称：配套费）。其中，在 2019 年 
      12 月底前新开工的酒店项目按 100% 缓交配套费，在 2020 年 12 月底前新开工的酒店项目，按 80% 缓交配套费，在 2023 年 12 月底前新开工的酒店项目，按 50% 缓交配套费。若按规定建设的并按协议约定期限完工的酒店项目，须于酒店项目竣工验收合格之日起 10 个工作日内持产业部门出具的确认函
      到新区规划建设行业主管部门完善办理相应比例配套费免交相关手续。若未按规定建设的或未按协议约定期限完工的酒店项目，须于产业部门通知之日起 10 个工作日内，补齐缴清缓交部分的配套费和从取得主体部分《建筑工程施工许可证》之日起参照人民银行同期贷款利息计算的滞纳金。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "成都麓客岛",
        contact: "",
        phone: "",
        img_count: 3,
        desc: `
        <h4 class="title">成都麓客岛</h4>
        <p>麓客岛秉持了“公园城市”的一发展理念，作为天府新区生态示范区，它的目标就是建成当代湖泊型城市休闲体育旅游综合体的典范。<br/>麓客岛由成都湖山文化旅游开发有限公司运营，位于成都市南延线中轴线上，北临成都高新区，南靠天府总部商务区，优越的地理位置造就了麓客岛体育产业聚集
        的特点。为实现景区生态价值高效转换，麓客岛集中发展休闲体育运动产业，通过构建新经济公园场景、新经济文创场景和体育运动场景等多功能叠加的生活消费场景，吸引体育产业项目落户聚集，实现“价值共创”。2019 年至今麓客岛自营收入和商家收入合计 2329万，经营利润 137 万。<br/>麓客岛主要运动
        项目包括云朵乐园、浪速运动皮划艇俱乐部、浩海潜水俱乐部、带你玩滑水俱乐部、滑噜噜四季滑雪场、达根斯国际马术俱乐部、雅克房车露营地等。麓客岛结合自身生态资源优势及商家优势，按照“体育为主、多业态联动”的商业新定位，打造“时尚运动体验”“家庭亲子旅行”“运动文创集市”三大消费新场景；麓客岛
        将运动比赛与旅游休闲结合，以组织承办多样的体育赛事活动为工作重点，充分发挥体育赛事聚人气的特点。2019 年接待游客 35 万人次，2020 年预计接待游客 50 万人次，预计实现收入约 2500 万。</p>`,
      },
    ],
  },
  {
    img_count: 3, //轮播图的数量
    areaId: "dongbuxin", //区域的id
    desc: `成都东部新区于 2020 年 4 月 28 日经四川省政府批复设立，管理范围 920 平方公里，辖海螺镇、芦葭镇、董家埂镇、壮溪镇、高明镇、武庙镇、丹景街道、玉成街道、草池街道、石板凳街道、福田街道、养马街道、石盘街道、三岔街道、贾家街道共 15 个镇（街）。2019 年常住人口 58 万人，地区生产总值 180 亿元。<br/>
    成都东部新区坚持公园城市发展理念，秉承山水丘陵特色，按照城市组群模式，立足自然资源特点、土地利用现状和产业发展方向，突出国际门户枢纽、国际交往中心、前沿产业基地、科技创新中心等功能，彰显公园城市特色，构建“双城一园、一轴一带”的空间布局，即：空港新城、简州新城、天府奥体公园，沱江发展轴和金简仁产业带。<br/>
    成都东部新区发展目标为：到 2025 年，城市形态基本显现，天府国际机场国际航空枢纽功能逐渐凸显，重大基础设施和公共服务设施基本覆盖新区，公共服务体系不断完善，绿色空间体系逐步健全，战略性新兴产业、现代服务业等加速集聚，法规治理和政策支撑体系全面建立。常住人口达到 80 万人，地区生产总值达到 480 亿元。
    到 2030 年，城市功能加快健全，科技创新能力明显增强，现代化产业体系基本形成，生态环境持续优化，公园城市品质显著提升，成德眉资同城化发展取得重大进展，成都国家中心城市功能的承载能力初步具备。常住人口达到 110 万人，地区生产总值达到 1300 亿元。到 2035 年，人城境业和谐统一的现代化城市基本建成，全球航
    空网络枢纽地位不断提升，成为国际门户枢纽城市的核心支点，新经济新动能形成支撑引领能力，辐射带动成渝相向发展的作用更加凸显，新发展理念引领高质量发展成效充分体现，集聚配置国际资源要素能力走在全国前列，基本建成美丽宜居公园城市示范区。常住人口达到 160 万人，地区生产总值达到 3200 亿元。<br/>成都东部新
    区将以习近平新时代中国特色社会主义思想为指导，全面贯彻习近平总书记对四川工作系列重要指示精神，扎实推动成渝地区双城经济圈建设，深入实施“一干多支、五区协同”“四向拓展、全域开放”战略部署，对标雄安新区，高起点规划、高标准建设、高质量发展、高水平治理，在产业发展、开放合作、生态文明、城乡融合、公共服务等领域
    先行先试、率先突破，全面增强高端要素资源的集聚配置能力，努力建设成为国家向西向南开放新门户、成渝地区双城经济圈建设新平台、成德眉资同城化新支撑、引领新经济发展新引擎和彰显公园城市理念新家园。
    `,
    popup: {
      title: "成都东部新区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/3/dongbu.png" class="bimg" />
      <p>重大项目采用一事一议方式</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "蓝溪湾国际旅游度假区",
        contact: "冯琴",
        phone: "028-86360237",
        img_count: 2,
        desc: `<h4 class="title">蓝溪湾国际旅游度假区</h4>
        <h4>建设地点</h4>
        <p>成都东部新区三岔湖滨湖区，位于三岔街道，距离成都天府国际机场约 10公里，18 号地铁线三岔 TOD 站 5 公里。</p>
        <h4>建设工期</h4>
        <p>待定</p>
        <h4>投资总额</h4>
        <p>待定</p>
        <h4>建设内容</h4>
        <p>打造国家级旅游度假区，包含航空航天科技主题乐园，湖景观光黄金岸线，运动主题公园，室内主题乐园群，滨湖度假酒店群 / 分时度假酒店，滨湖特色主题民宿聚落，度假社区 / 公寓，滨水自驾露营基地等业态。</p>
        <h4>建设条件</h4>
        <p>总面积约 6 平方公里，其中位于 0-200米湖岸线范围外建设用地约 3 平方公里。</p>
        <h4>合作方式</h4>
        <p>待定</p>
        <h4>联系方式</h4>
        <p>成都东部新区文化旅游体育局<br/>
           冯琴 028-86360237</p>`,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "丹景半山民宿度假群落",
        contact: "冯琴",
        phone: "028-86360237",
        img_count: 2,
        desc: `
        <h4 class="title">丹景半山民宿度假群落</h4>
        <h4>建设地点</h4>
        <p>成都东部新区天府奥体公园山地运动区（武庙镇），邻近丹景台和三岔湖景区，距离成都天府国际机场 10 公里，18 号地铁线三岔TOD 站 3 公里。</p>
        <h4>建设工期</h4>
        <p>待定</p>
        <h4>投资总额</h4>
        <p>1 亿元</p>
        <h4>建设内容</h4>
        <p>依托龙泉山城市森林公园自然资源和丹景山深厚的历史文化，打造以半山隐居、森林康养为特色的高端隐奢半山民宿群落。项目位于成都东部新天府奥体公园山地运动区。</p>
        <h4>建设条件</h4>
        <p>占地面积约 100 亩，组团式布局院落式精品民宿，形成各具特色阶梯式民宿群落</p>
        <h4>合作方式</h4>
        <p>待定</p>
        <h4>联系方式</h4>
        <p>成都东部新区文化旅游体育局<br/>
           冯琴 028-86360237</p>`,
      },
    ],
  },
  {
    img_count: 3, //轮播图的数量
    areaId: "gaoxin", //区域的id
    desc: `2019 年，成都高新区实现地区生产总值2285.6 亿元。<br/>成都高新区筹建于 1988 年，1991 年获批全国首批国家级高新区，2006 年被科技部确定为全国创建“世界一流高科技园区”试点园区，2015 年经国务
    院批准成为西部首个国家自主创新示范区，是四川省全面创新改革试验区和自由贸易试验区核心区。成都高新区现有面积 234.4 平方公里，依托高新南区（成都新经济活力区、交子公园金融商务区）、高新西区（电子信息产业功能区）
    、成都天府国际生物城和未来科技城，加快建设国家高质量发展示范区和世界一流高科技园区。<br/>当前，新经济活力区正以瞪羚谷产业社区、骑龙湾产业社区、AI 创新中心、中国 - 欧洲中心、新川创新科技园和天府软件园六大产业
    社区为抓手，聚焦 5G 通信与人工智能、网络视听与数字文创、大数据与网络安全等新经济产业主攻方向，加快建设具有全球影响力的新经济策源地和活力区。
    `,
    popup: {
      title: "成都高新区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/4/gaoxin.png" class="bimg" />
      <h4>《成都高新技术产业开发区关于优化产业服务促进企业发展的若干政策意见（修订）》（成高管发〔2020〕6 号）</h4>
      <p>对申报年度营业收入、销售额 ( 营业额 ) 增幅超过 10%，地方实际贡献同比增长的规模以上服务业企业、限额以上商贸服务业企业，按照申报年度营业收入、销售额 ( 营业额 ) 同比增长 2 亿元及以上、1亿元 ( 含 1 亿元 
      )-2 亿元、5000 万元 ( 含 5000 万元 )-1 亿元、1000 万元 ( 含 1000 万元 )-5000 万元，分别给予最高不超过 200 万元、100 万元、50 万元、30 万元奖励。</p>
      <h4>《< 成都高新技术产业开发区关于优化产业服务促进企业发展的若干政策意见（修订）> 实施细则》</h4>
      <h4>（五）鼓励企业规模上台阶</h4>
      <p>对申报年度营业收入增幅超过 10%，地方实际贡献同比增长的规模以上服务业企业，营业收入每增加 1000 万元，给予 5 万元奖励，最高奖励不超过 200 万元；对申报年度销售额（营业额）增幅超过 10%，地方实际贡献同
      比增长的限额以上商贸服务业企业，批发业企业每增加 5000 万元，给予 5 万元奖励，零售业、住宿业和餐饮业企业每增加 1000 万元，给予 5 万元奖励，最高奖励不超过 200 万元。</p>
      <h4>（八）支持企业加强安全生产</h4>
      <p>对通过安全生产标准化达标的企业给予最高10 万元的一次性奖励，其中：规模以上工业企业、资质等级建筑业企业、限额以上批零住餐企业和规模以上服务业企业初次达标的奖励 10 万元，按期复评达标的奖励 5 万元；其它
      企业初次达标的奖励3 万元，按期复评达标的奖励 1．5 万元。接入成都市安全生产综合监管平台的企业给予 10 万元一次性奖励。对初次获得职业健康安全管理体系认证的企业给予 2 万元一次性奖励。对初次获得成都市职业健康
      示范单位的企业给予 10 万元一次性奖励。</p> 
      <h4>政策体系完备</h4>
      <h4>产业招引政策</h4>
      <p>成都高新技术产业开发区关于加快金融业高质量发展的若干政策成都高新区关于加快聚集高能级 500 强企业增强经济高质量发展动能的若干政策。</p>
      <h4>产业服务政策</h4>
      <p>成都高新技术产业开发区关于优化产业服务促进企业发展的若干政策意见（修订）</p>
      <h4>产业培育政策</h4>
      <p>成都高新技术产业开发区关于深化产业培育实现高质量发展若干政策意见（修订）成都高新技术产业开发区关于促进生物产业生态圈（产业功能区）成型成势发展的若干政策（修订）。</p>
      <h4>人才激励政策</h4>
      <p>成都高新区实施“金熊猫”计划促进人才资源向创新动能转化若干政策。</p>
      <h4>科技创新政策</h4>
      <p>成都高新技术产业开发区关于科技创新驱动高质量发展的若干政策。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "瞪羚谷数字文创产业基地",
        contact: "",
        phone: "",
        img_count: 2,
        desc: `
        <h4 class="title">瞪羚谷数字文创产业基地</h4>
        <p>瞪羚谷是深入贯彻习近平总书记来川视察重要指示精神，按照公园城市理念规划建设的新型产业社区。社区遵循公园城市发展理念，将川西林盘风貌植入城市空间设计，着力打造人、城、产融合发展的生态谷地。</p>
        <p>基地位于成都新经济活力区核心位置，选址天府绿道锦城湖畔，剑南大道两侧，西起成昆铁路，东至益州大道，北临锦城大道，南到盛邦街，规划面积 4.6 平方公里，恪守 39% 生态用地、46% 生活用地、15% 生产用地的科学规划占
        比，以都市林盘引领形成人、城、境、业高度和谐统一的大美城市形态，以生态谷地将生态价值与经济价值、生活价值、社会价值有机融合交相辉映，是全面体现新发展理念的公园，城市产业社区典范。</p>
        <p>瞪羚谷数字文创产业基地是成都高新区新经济发展的重要承载地，重点聚焦游戏电竞、数字音乐、数字传媒、影视制作等产业细分领域，打造产业生态最完善的文化创意都市林盘。</p>
        <h4>建设地点</h4>
        <p>基地位于成都新经济活力区核心位置，选址天府绿道锦城湖畔，剑南大道两侧，社区西起成昆铁路，东至益州大道，北临锦城大道，南到盛邦街。</p>
        <h4>重点项目:</h4>
        <h4>1. 铁像寺水街</h4>
        <p>占地 162 亩，规划面积 12.2 万平方米。一期占地 78 亩 , 建筑面积 4.5 万平方米，已于 2013 年投入使用，曾荣获“成都市特色商业街区”、“成都最美街道” 等称号 ; 二期占地 84 亩，建筑面积 7.7 万平方米，预计 2021 年竣工。</p>
        <h4>2. 天府长岛文创中心</h4>
        <p>占地 278.5 亩，规划面积 24 万平方米。一期已建成， 建筑面积 10 万平方米，共 82 栋 124 套独栋低密度办公用房，配套已建成 1800 平方米餐厅及 2100 平方米健身房 ; 二期建筑面积 14 万平方米，已开工建设，预计 2020 年竣工。</p>
        <h4>3. 文化艺术中心 (在建)</h4>
        <p>占地 135 亩，规划面积 6.6 万平方米。一期已开工建设，预计 2021 年竣工。</p>
        <h4>4. 文商国际中心</h4>
        <p>占地 231 亩，规划建筑面积 31 万平方米。</p>
        <h4>周边配套：</h4>
        <p>瞪羚谷数字文创产业基地依托天府绿道、锦城湖等生态资源，打造国际范、成都味的都市林盘社区。基地毗邻锦城湖、桂溪生态公园、金融城孵化园，具备完善的商业及基础设施配套。项目周边云集石室天府、成都七中高新校区、蒙彼利埃国际学校、霍森斯、墨
        池书院等优质教育资源。 </p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "新川创新科技园",
        contact: "",
        phone: "",
        img_count: 3,
        desc: `
        <h4 class="title">新川创新科技园</h4>
        <h4>着力建设“成都 5G 智慧城”</h4>
        <h4>规划面积</h4>
        <p>10.34 平方公里</p>
        <h4>引入项目</h4>
        <p>中国移动（成都）产业研究院、新华三成都研究院、欧珀（OPPO）等重大产业化项目。</p>
        <h4>功能区域</h4>
        <p>策划实施成都 5G 智慧城先导区等六大板块</p>
        <h4>5G 智慧城先导区</h4>
        <p>占地 522 亩，围绕大数据、 物联网、车联网、云计算产业，打造高质量科创空间、高品质生活示范区。</p>`,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "生物城凯悦",
        contact: "",
        phone: "",
        img_count: 2,
        desc: `
        <h4 class="title">生物城凯悦</h4>
        <p>生物城凯悦嘉轩酒店是高新区首家国资平台与国际酒店品牌合作的酒店类配套项目，助力生物城园区营商环境建设，提升生物城品牌形象，完善园区生活环境。酒店品牌选定为凯悦国际酒店旗下的商务高端型系列 - 凯悦嘉轩，旨在为生物城高端人群打造融
        心灵栖居和舒适享受为一体的旅宿空间及商务场所。凯悦国际（亚太）有限公司与国际生物城合作，在园区设立高品质国际星级酒店，作为其凯悦嘉轩的品牌特许主体，授予该酒店使用“凯悦嘉轩”品牌及酒店系统的特许权，酒店入住顾客享受凯悦天地忠诚旅客
        计划承诺的同等礼遇。该酒店为园区入驻企业及高层次商务人士提供人性化又现代时尚的高端商务休闲及大型会务服务。完善产业园区功能配套，提升园区国际营商环境，助力呈现高品质国际社区。</p>
        <h4>建设地点</h4>
        <p>酒店位于生物城孵化园西侧 E2 地块</p>
        <h4>建设工期</h4>
        <p>2022 年 6 月</p>
        <h4>投资总额</h4>
        <p>总投资 3 亿元</p>
        <h4>建设内容</h4>
        <p>目前正在进行主体施工，建筑面积共 3.18 万平方米，总房间数 262 间。</p>`,
      },
    ],
  },
  {
    img_count: 2, //轮播图的数量
    areaId: "qingyang", //区域的id
    desc: `青羊区，原名西城区，因区内著名道观“青羊宫”而得名，是成都的地理原点和历史起点所在地、古代南方丝绸之路的起点，也是天府文化的发祥地。青羊历史文化资源深厚，聚集中心城区三分之二以上的文化旅游资源。宽窄巷子、金沙遗址、杜甫草堂等已驰名
    中外，A 级景区、星级饭店也是随处可见。区域内的成都国际非物质文化遗产博览园，获批国家级文创产业园，也是国际非遗节的永久会址、非遗生产性保护的永久平台。<br/>近年来，青羊区紧紧围绕“千年蜀都 文博青羊”总体定位，深入实施“旅游 +”战略，加速推
    进旅游与文化、体育、健康等产业深度融合发展，先后获评“全国文博旅游标准化示范区”“全国都市文化旅游服务产业知名品牌创建示范区”“最美中国文化旅游特色魅力目的地城市”“四川省旅游标准化示范单位”“四川首批天府旅游名县”“四川省全域旅游示范区”等多
    项殊荣。2019 年全区共接待游客 2534.51万人次，实现旅游综合收入 289.13 亿元，分别同比增长 39.23％、30.71％。<br/>曾被美国《时代周刊》评价为“成都最中国、青羊最成都”的青羊不仅历史文化悠久，这里还是宜居宜业的公园城区。地处“西贵”区域的青羊，
    交通十分便捷，距双流国际机场仅 30 分钟车程、蓉欧快铁起点 45 分钟车程，拥有大型交通枢纽成都西客站，轨道交通遍布青羊，建成和规划地铁线路多达 16 条，已形成“纵横交错”的骨干路网；人居环境优美，森林覆盖率达 22.9％，生活危废无害化处理率 
    100％，全年空气优良天数居全市前列，地处城市上风上水的青羊正加快建设美丽宜居公园城区；区内教育医疗资源集聚，中国最具影响力中小学百强榜，青羊就有 4 家学校上榜。拥有各级各类医疗机构 708 家，三甲医院 6 家，每平方公里平均就有 10 余家专业医疗机构。<br/>
    如今，青羊正以商务、文博、金融三大主导产业为重点，大力实施“双擎驱动”战略 , 着力优源城、建新城，形成了“双心引领、两轴驱动、六廊环绕、多点支撑”的发展格局。<br/>千年历史文化的传承复兴、宜居宜业的高端品质、人性化的现代治理模式和高水准国际化的城市格局，将是您投资创业、居家旅游的理想之地。
    `,
    popup: {
      title: "青羊区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/5/qinyang.png" class="bimg" />
      <h4>成都市青羊区文化体育和旅游局关于印发《青羊区关于促进文博创意产业发展的若干支持政策》</h4>
      <p>第十一条 鼓励酒店集团化、规模化发展，对区内中小酒店进行资产重组形成酒店集团，产生较好的效益，按实际重组费用的3%—5%，给予集团酒店最高可达 100 万元的一次性补贴。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "西环广场 5 号楼项目",
        contact: "张文浩",
        phone: "13308190266",
        img_count: 2,
        desc: `
        <h4 class="title">西环广场5号楼项目</h4>
        <h4>建设地点</h4>
        <p>成都市青羊区光华东三路 489 号</p>
        <h4>建设工期</h4>
        <p>2012 年 7 月开工建设，2014 年 12 月停工</p>
        <h4>投资总额</h4>
        <p>已投入资金约 1.7 亿元人民币</p>
        <h4>建设内容</h4>
        <p>星级酒店</p>
        <h4>建设条件</h4>
        <p>土建部分接近结束，机电部分暂未施工</p>
        <h4>合作方式</h4>
        <p>股权转让</p>
        <h4>联系方式</h4>
        <p>张文浩 13308190266</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "华住集团酒店（待定）",
        contact: "吴先生",
        phone: "15365521225",
        img_count: 3,
        desc: `
        <h4 class="title">华住集团酒店</h4>
        <h4>建设地点</h4>
        <p>上同仁路一号</p>
        <h4>建设工期</h4>
        <p>预计 2021 年 4 月投入使用</p>
        <h4>投资总额</h4>
        <p>4000 万</p>
        <h4>建设内容</h4>
        <p>酒店</p>
        <h4>建设条件</h4>
        <p>在原泸天化酒店基础上翻新，改建客房</p>
        <h4>合作方式</h4>
        <p>华住集团租赁泸天化酒店后投资装修改建</p>
        <h4>联系方式</h4>
        <p>15365521225 吴先生</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "文庙西街地块项目",
        contact: "史老师",
        phone: "1340283829",
        img_count: 3,
        desc: `
        <h4 class="title">文庙西街地块项目</h4>
        <h4>建设地点</h4>
        <p>文庙西街 106 号</p>
        <h4>建设工期</h4>
        <p>待定</p>
        <h4>投资总额</h4>
        <p>4 亿以上</p>
        <h4>建设内容</h4>
        <p>面积 17.5 亩，住宅性质（待调规商业），容积率≤ 4.0</p>
        <h4>建设条件</h4>
        <p>待定</p>
        <h4>合作方式</h4>
        <p>待定</p>
        <h4>联系方式</h4>
        <p>史老师 1340283829</p>
        `,
      },
    ],
  },
  {
    img_count: 2, //轮播图的数量
    areaId: "chenghua", //区域的id
    desc: `
    成华区成立于 1990 年，成都中心城区之一，原成都东郊老工业基地，面积约 110 平方公里，辖 11 个街道，常住人口 120 余万人。紧扣“成于中优·华在文商”和美丽宜居公园城市示范区，打造世界旅游目的地。<br/>
    中国商业地产最具投资潜力城区、<br/>
    中国最具幸福感城区、<br/>
    中国最具投资价值城区、<br/>
    全国文化先进单位、<br/>
    全国生态文明先进城区<br/>
    拥有独具魅力的“文化价值”<br/>
    <img src="./images/area/6/jian.png" class="cimg" />
    全球独一无二的熊猫都市乐园，承接来蓉 70% 以上的外国游客，大熊猫成为名副其实的国家名片 ; 始建于唐代的昭觉寺“川西第一禅林”、沙河“三洞桥”清代
    建筑作品，增添古蜀文化底蕴 ; 馆藏 6 万余件自然珍品的成都理工大学博物馆，直观演绎人类文明发展历程 ;全国第四、西部第一高塔一一天府熊猫塔，高 339 米，揽尽望平坊、“ 夜游锦江”美景 ; 拥有成都最丰厚的工业文明底蕴，非常有价值的工业遗迹 14 处、占全市 50%，2 处被列为省级文物保护单位。东郊记忆、完美
    世界文创公园等工业遗存和活化利用，已成为文商旅融合发展的“ 新地标”，成为让全球朋友认识成都和成华、让天府文化通向世界的“ 新窗口”。<br/>拥有主城区最绿最灵动的“生态价值”<br/>绕城内绿地最多，环城生态区面积 22.65 平方公里，规划绿地总量达 34 平方公里，这是相当于 200 个人民公园的面积。除此之外，
    还拥有绕城内最大的水面，规划有 3000 余亩北湖和 4600 余亩水面湿地，相当于 2 个杭州西湖。<br/>具备全市唯一的交通、通信“双枢纽价值”<br/>具有西南最大、全国第六的综合交通枢纽成都东站，目前日客流量达 30 万人次，未来将达 100 万人次 ; 成渝、成绵等 5 条高速路汇聚成华，全省 IP 互联网和成都通信大
    数据服务“ 总枢纽”安家成华，这两大枢纽优势叠加，将会迸发出巨大动能。
    `,
    popup: {
      title: "成华区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/6/chenghua.png" class="bimg" />
      <h4>中共成都市成华区委、成都市成华区人民政府、关于成华区勇当成都建设国家中心城市排头兵、支持实体经济发展若干政策的意见</h4>
      <p>第二十三条、对新办的都市旅游企业，自企业注册之日起，在我区年度经济贡献 50 万元及以上的，前 3年以企业在我区年度地方经济贡献的 100% 为参照数，后 2 年以企业在我区年度地方经济贡献的 50% 为参照数给予企业扶持资金，其中 30% 可用于奖励企业经营者或高级管理人员。</p>
      <p>第七十八条、对达到国家标准并首次成功纳入国家统计网报企业库的批发、零售、住宿、餐饮企业，给予企业经营者及相关人员 8 万元一次性奖励。</p>
      <p>第三十五条、对新评定且为首次评定的星级旅游饭店，按三星级、四星级、五星级的标准，分别给予企业 50万元、150 万元、300 万元一次性奖励。三星级升四星级、四星级升五星级的按上述标准差额部分给予企业一次性奖励。</p>
      <p>第九十一条、年主营业务收入 1500 万元及以上的星级旅游饭店，主营业务收入较上年度同比持平或同比增长 5% 以内的，给予企业 4 万元一次性奖励，在同比增长 5% 的基础上，增长比例每增加 1%，另给予企业 2 万元一次性奖励，依次递增后，单户企业每年累计奖励最高不超过 20 万元，其中 50% 可用于奖励企业经营者及相关人员。</p>
      <p>第八十五条、年营业额 1000 万元及以上的住宿和餐饮企业，年营业额较上年度同比持平或同比增长 10%以内的，给予企业 2 万元一次性奖励，在同比增长10% 的基础上，增长比例每增加 1%，另给予企业 1万元一次性奖励，依次递增后，单户企业每年累计奖励最高不超过 20 万元，其中 50% 可用于奖励企业经营者及相关人员。</p>
      <p>第九十三条、年主营业务收入首次突破 1500 万元、3000 万 元、5000 万 元 的 星 级 旅 游 饭 店， 分 别 给 予企业 10 万元、20 万元、30 万元一次性奖励，其中50% 可用于奖励企业经营者及相关人员。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "多元总部国际 1 号二期项目",
        lianxifang: "龙潭新经济管委会",
        phone: "84200044",
        img_count: 1,
        desc: `
        <h4 class="title">多元总部国际1号二期项目</h4>
        <h4>建设地点</h4>
        <p>成都龙潭新经济产业功能区成致路 6 号</p>
        <h4>建设工期</h4>
        <p>——2022 年 6 月</p>
        <h4>建设内容</h4>
        <p>用地性质为一类工业用地，占地面积 38393.94 ㎡，规划总建筑面积约为 95030.85 ㎡，由四川多元德泰投资有限公司（以下简称多元公司）投资建设。项目分两期进行建设，一期工程规划面积约 29952.01 ㎡已竣工投产；二期工程建设规划面积约 65078.84 ㎡，正在建设，预计2022 年 6 月竣工。</p>
        <h4>投资总额</h4>
        <p>1 亿元</p>
        <h4>建设条件</h4>
        <p>实地查勘，主体已建成</p>
        <h4>合作方式</h4>
        <p>购买、双方合作开发</p>
        <h4>联系方式</h4>
        <p>龙潭新经济管委会：84200044</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "蓉城渝商总部基地项目",
        lianxifang: "龙潭新经济管委会",
        phone: "84200044",
        img_count: 1,
        desc: `
        <h4 class="title">蓉城渝商总部基地项目</h4>
        <h4>建设地点</h4>
        <p>成都龙潭新经济产业功能区华实路</p>
        <h4>建设工期</h4>
        <p>2022 年 12 月</p>
        <h4>投资总额</h4>
        <p>4 亿元</p>
        <h4>建设内容</h4>
        <p>用地性质为一类工业用地，占地面积 28.25 亩</p>
        <h4>总建筑面积</h4>
        <p>9.85 万㎡，预计修建 4 栋大楼，现建成 3 栋主体，A 栋 25 层暂未建设。</p>
        <h4>建设条件</h4>
        <p>实地查勘，B、C、D 三栋主体已完工</p>
        <h4>合作方式</h4>
        <p>购买、双方合作开发</p>
        <h4>联系方式</h4>
        <p>龙潭新经济管委会：84200044</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "合信 K101 项目",
        lianxifang: "东郊艺术区管委会",
        phone: "84326199",
        img_count: 1,
        desc: `
        <h4 class="title">合信K101项目</h4>
        <h4>建设地点</h4>
        <p>东郊记忆艺术区二仙桥片区</p>
        <h4>建设工期</h4>
        <p>2020 年——2023 年</p>
        <h4>建设内容</h4>
        <p>合信 K·101 总占地面积约 145 亩，总建筑面积约 41 万平米， 是集PANDA MALL、红砖艺展中心、工业故事商业街、洲际英迪格五星级酒店、5A 甲级写字楼等于一体的中国 TOD文创旅游综合体。业态涵盖写字楼（6.8 万㎡）、酒店（5.17 万㎡）、购物中心及商业街（6.27 万㎡）。</p>
        <h4>投资总额</h4>
        <p>20 亿元</p>
        <h4>建设条件</h4>
        <p>项目规划设计方案已通过土规会</p>
        <h4>合作方式</h4>
        <p>公开招租</p>
        <h4>联系方式</h4>
        <p>东郊艺术区管委会 84326199</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "红仓·禾创文创产业园区项目",
        lianxifang: "东郊艺术区管委会",
        phone: "62725836",
        img_count: 3,
        desc: `
        <h4 class="title">红仓·禾创文创产业园区项目</h4>
        <p>红仓·禾创文创产业园区项目位于二仙桥西路 398 号，项目总占地面积 28 亩，建筑面积 17.5 万平方米，将致力于打造“工业遗产 + 文创园区 + 产业高地 + 创新社区”为共生模式的产城生态体系，形成包含文化主题酒店、甲级写字楼、文创商业街区、数字展博空间等于一体的文商旅融合体验新地标。</p>
        <h4>建设地点</h4>
        <p>东郊记忆艺术区二仙桥片区</p>
        <h4>建设工期</h4>
        <p>2019 年——2022 年</p>
        <h4>投资总额</h4>
        <p>142 亿元</p>
        <h4>建设条件</h4>
        <p>项目按施工进度计划正常推进</p>
        <h4>合作方式</h4>
        <p>公开招租</p>
        <h4>联系方式</h4>
        <p>东郊艺术区管委会 62725836</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "泊里中心",
        contact: "韩先生",
        phone: "181-1303-8308",
        img_count: 2,
        desc: `
        <h4 class="title">泊里中心</h4>
        <h4>项目名称</h4>
        <p>泊里中心</p>
        <h4>建设地点</h4>
        <p>成华区迎晖路 66 号</p>
        <h4>建设工期</h4>
        <p>900 天</p>
        <h4>投资总额</h4>
        <p>3.5 亿元</p>
        <h4>建设内容</h4>
        <p>项目投资方与锦江国际酒店集团共同建设高品质酒店项目投资方与锦江国际酒店集团共同建设高品质酒店</p>
        <h4>建设条件</h4>
        <p>待定</p>
        <h4>合作方式</h4>
        <p>待定</p>
        <h4>联系方式</h4>
        <p>韩先生 181-1303-8308</p>
        `,
      },
    ],
  },
  {
    img_count: 3, //轮播图的数量
    areaId: "wuhou", //区域的id
    desc: `
    <h4>一、武侯区区情概况</h4>
    <p>武侯区作为成都市的中心城区之一，面积 75.36平方公里，人口 138 万，是国务院命名的高科技文化区，中西部经济社会发展的领先区。以成都建设“三城三都”为引领，武侯将文创产业放在三大主导产业首位，大力建设“文创武侯·智慧城区”。</p>
    <p>一是文旅资源富集。武侯区素有“三国圣地”“蜀汉名城”之美誉，先后被评为“四川省旅游标准化示范区”和“四川省旅游强区”。</p>
    <p>二是经济实力雄厚。武侯区 2019 年地区生产总值达到 1201.5 亿元人民币，民营经济综合实力连续多年领跑全省，106 家世界 500 强企业在武侯区落户发展，约占成都市世界 500 强企业总数的 37%。</p>
    <p>三是创新动力强劲。武侯区是“中国科技进步示范区”，科教资源丰富，区内聚集了中科院成都分院等 130 余家科研院所，拥有川大智胜等高新技术企业283 家，创新创业孵化器 47 家，是中国“国家知识产权强县工程示范区”。</p>
    <p>四是宜居品质高端。武侯区交通纵横畅达、教育品质优良、医疗资源富集，是“全国区域教育均衡发展特色示范区”，也是中国医疗资源最为富集的区域之一。</p>
    <p>五是营商环境优越。武侯区是中国最佳国际营商环境城区”“全国行政服务标准化示范区”，全区产业保障机制完善，三大主导产业分别建立了“五位一体”产业发展保障体系，先后出台了 9 大类共 24 项产业扶持政策，2019 年扶持企业投入达 17 亿元。</p>
    <p>六是产业载体充裕。武侯区楼宇资源聚集，区内现有高端商务商业楼宇 141 栋，在建高端楼宇 20 栋，是“中国楼宇经济最具投资价值城区”“中国楼宇经济十大活力城区”。</p>
    <h4>二、武侯区文创产业发展概况</h4>
    <p>武侯区确立了“文创武侯·智慧城区”的战略地位，提出了建设“历史文化名区、西部文创强区”的总体目标，着力打造“三国故里·天府文芯”文创品牌，建设文商旅体融合发展基地，扎实推进“国家全域旅游示范区”和“天府旅游名区”创建工作，以产业融合发展为依托，以强化招引力度为抓手，按照产业现代化发展思路，有力地推动了文化、旅游事业的发展，产业的主导态势日益显现，市场主体发
    展活跃，开创了“文创产业”发展新局面。2019 年，我区实现文创产业增加值 101.56 亿元；实现旅游总收入 273.9亿元，接待游客 2652.98 万人次。</p>
    <p>制定出台了《建设“文创武侯”行动计划（2018—2021 年）》，提出积极实施“人文润城”“文化地标”“产业强基”“品牌塑造”“人才荟萃”五大行动，充分体现了文化传承与创新创意、整体谋划与重点突破、系统部署与分类推进的深度结合，重点发展影视、音乐、体育电竞、文博旅游、数字娱乐、创意设计六大产业方向。</p>
    <p>2019 年 7 月武侯区委、区政府印发《成都市武侯区文商旅体融合发展基地建设实施方案》，鲜明提出了推动人文感召力、旅游吸附力、市场供给力、产业竞争力“四个显著提升”的发展愿景，到 2021 年，将实现旅游接待人次和旅游总收入“两个突破”和文创产业市场主体和产业增加值“两个翻番”的发展目标。</p>
    <p>一是要构建“一核二带三轴四片”文商旅体产业空间布局。即以三国文创产业功能区为核心，以锦江滨水文创带、环城生态文旅带为环绕，以人民南路文创商务轴、川藏路文旅商贸轴、武青路文化科创轴为延伸，以四大历史文化风貌片区为支撑，构建文商旅体产业空间布局。二是要建设一批文商旅体融合发展重大项目。全力推进锦里、望江坊、音乐坊、华西坝、天府芙蓉园、水韵天府文化旅游休闲街
    区建设，丰富我区文商旅体融合发展的功能性枢纽型产业项目，高标准高质量带动我区文商旅体融合发展。三是要构建一批文商旅体融合发展应用场景。通过创建一批示范园区、打造一批特色街区、布局一批小微空间、提升一批消费载体、建设一批综合场馆、推出一批旅游线路，建强文商旅体融合发展基地。四是要实施一批文商旅体融合发展重点工程。重点实施文化根脉传承创新工程、文商旅体市场
    主体壮大工程、城市人居环境美化工程、文化旅游品质提升工程、“旅游 +”业态融合创新工程、节会赛事引进培育工程和城市营销与品牌推广工程“七大工程”。五是要着力完善文商旅体融合发展保障体系。将从健全体制机制、优化营商环境、夯实政策支撑、强化人才保障、加强督导考核 5 个方面，切实保障文商旅体融合发展基地建设。</p>
    `,
    popup: {
      title: "武侯区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/7/wuhou.png" class="bimg" />
      <p>在武侯区新注册登记的具有独立法人资格的文博旅游企业，年度经济贡献在 20 万元（含）以上的，经区文化主管部门认定，自企业纳税之日起，以其对武侯区实际经济贡献为参照数，前两年按 100% 给予产业扶持，后三年分别按 80%、60%、40% 给予产业扶持。</p>
      <p>推进智慧旅游建设。对达到成都智慧旅游景区、饭店、旅行社标准的旅游景区、饭店、旅行社，按所获得市级奖励金额的 50% 给予补贴，最高不超过 10万元。</p>
      <p>对新建、提升的具有创意特色的实体书店、书院、小剧场、工作室、客栈等文创空间，经区文化主管部门认定，按建设、改建经费的 20% 给予最高不超过 5万元的一次性补贴。鼓励文旅融合发展。对景区景点积极提升服务品质，并获评 2A 级（含）以上景区的，按其改造总投入的 20% 给予补贴，单个景区最高补贴 300 万元。对获权威部门认定的旅游品牌，包括工业旅游、体育旅游、健康旅
      游、研学旅游、森林康养等示范基地（区），最高给予 100 万元的一次性奖励。对积极提升接待能力的旅行社、酒店、客栈、民宿最高给予 30 万元的一次性奖励。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "“成都音乐坊”文化旅",
        contact: "杨丁霁",
        phone: "18702878726",
        img_count: 3,
        desc: `
        <h4 class="title">“成都音乐坊”文化旅</h4>
        <h4>项目背景</h4>
        <p>成都音乐坊位于锦江南岸，以城市音乐厅为中心，以四川音乐学院为依托，规划面积约1.2 平方公里，南至一环路南一段、西至新南路、东至锦江的一个“钻石形”区域。区域内交通网络发达，生活配套完善，目前已呈现城市音乐厅、黑胶广场、音乐大道等特色场景，为推进成都市“三城三都”世界级“音乐之都”建设工作，已在音乐坊核心区域内引入了 70 余家音乐文化企业，涵盖了五大音乐
        支柱产业：音乐演艺产业、原创音乐孵化产业、乐器产销综合产业、音乐培养及教育产业和音乐文化传播版权产业。</p>
        <h4>建设条件</h4>
        <p>音乐坊片区建设条件良好，核心区域内生活、交通设施完善，一是现有四宗待上市商业用地可用于建设打造高端音乐文博、旅游产业；二是已呈现的黑胶广场、音乐大道、音乐产业中心等空间场景可用于引入公共演出，发展文化旅游产业；三是音乐特色街区基本呈现，与历史锦江紧密相连，重现老码头水岸与夜游锦江的盛景，对片区第三产业提档升级，提升“旅游 +”消费产业奠定了基础。</p>
        <h4>总体定位</h4>
        <p>落实“三城三都”建设要求，建成世界级“音乐之都”的核心区和国际音乐生态示范区，打造成都特色“音乐 +”、文化旅游高地。</p>
        <h4>建设内容</h4>
        <p>音乐坊片区重点建设内容包括：一是核心区域内四宗可供上市的商业用地，拟引入高端音乐文博、旅游等产业，目前四宗地块规划指标已落地；二是发掘现存优质载体包括凯悦新城、嘉谊大厦、川艺校等，回收统一运营管理，提档升级现存业态，推动区域音乐、文化旅游产业发展，目前载体收储工作正在落实中；三是结合片区城市设计方案，依托现有的空间载体，在公共区域打造音乐主题场景，建成音乐坊特色街巷包括音乐大道、沿江街巷、凯莱国际步行街等，营造城市旅游氛围。</p>
        <h4>投资效益</h4>
        <p>预计到 2024 年，音乐坊片区将入驻企业超 1000 家，产业聚集程度由 30% 上升到 70%，新增就业人口 3 万人，产值 100 亿。</p>
        <h4>建设地点</h4>
        <p>位于成都市武侯区， 一环路南一环段、 新南路、锦江所夹的 “钻石型区域”。</p>
        <h4>建设工期</h4>
        <p>5 年</p>
        <h4>投资总额</h4>
        <p>一阶段总投资 77 亿</p>
        <h4>合作方式</h4>
        <p>投资共建</p>
        <h4>联系方式</h4>
        <p>杨丁霁 18702878726  313633670@qq.com</p>
        `,
      },
    ],
  },
  {
    img_count: 3, //轮播图的数量
    areaId: "jinniu", //区域的id
    desc: `
    <h4>交子故里 大道金牛</h4>
    <p>秦开蜀道置金牛，汉水元通星汉流。金牛区是成都中心城区，面积 108 平方公里，辖 15 个街道和 1个省级工业开发区，常住人口 121 万。是全国领先“职务科技成果混合所有制改革”策源区、西部唯一“国家级市场采购贸易方式”试点区、全省唯一“国家可持续发展”先进示范区。</p>
    <p>2019 年全区地区生产总值约 1300 亿元一般公共预算收入 87.7 亿元全区接待游客总量达 1480.32 万人次，实现旅游总收入 290 亿元，文创产业增加值突破 120 亿元。区域内 9122 处文化资源和 1385 处旅游资源。全区现有文创企业 9480 家，其中，宾馆酒店 473 家，旅行总社 66 家；规模以上 199 家，年产值上亿元的达到 47 家。4A 级旅游景区欢乐谷连续四年
    获评“亚太地区主题公园 20 强”；2A 级旅游景区易园园林艺术博物馆是省内唯一以易经文化为主题的川派山水园林民营博物馆。西藏饭店荣获四川省旅游行业金熊猫奖，天湖宾馆等 6 家酒店被评“绿色旅游饭店”，铁道大酒店等 4 家酒店入选全省首批特色文化主题饭店。</p>
    <h4>人文金牛，历史厚重</h4>
    <p>金牛是天府文化发端的根基，境内有金沙遗址为代表的古蜀文化遗址、有见证巴蜀文明与中原文化开放融合的金牛古道、有中国第一个科学考古发掘的皇帝陵前蜀永陵。老官山出土的汉代提花织机模型达到了蜀锦技术的巅峰，延续 1000 多年的九里堤开创了成都“两江环抱”的城市格局，世界最早纸币交子制造地净众寺蕴藏着厚重的历史文化，李劼人《死水微澜》还原出民国攘来熙往的天回镇风貌。</p>
    <h4>活力金牛，经济繁荣</h4>
    <p>金牛是成都商贸市场、科研院所最为集中的区域，拥有全国闻名的“川派服饰基地”荷花池市场、全国唯一覆盖全产业链的轨道交通产业园；拥有西部规模最大的商品综合交易平台——成都国际商贸城、西部第一个以“北斗”为主题的地理信息产业园；拥有全省首个“中国工业大奖”和中医药、五金机电两个“国家级指数”。</p>
    <h4>开放金牛，投资热土</h4>
    <p>金牛地处成德绵经济带的起点和天府大道“百里中轴线”北中轴的核心位置，拥有西南最大的铁路枢纽成都火车站，是轨道交通规划站点最多的主城区。拥有西部唯一的“国家级市场采购贸易方式”试点，将打造成为泛欧泛亚进口商品展示和出口商品集散中心。拥有可利用土地 3 万余亩，是土地资源最丰富的主城区。拥有市场主体 31 万户，总量位列全省区（市）县第二。</p>
    <h4>美丽金牛，公园城区</h4>
    <p>金牛上风上水，天回山、凤凰山“两山作屏”，府河、沙河等“八水润城”，环城生态区 21.7 平方公里，河流总长 230.3 公里。拥有中国唯一一座以露天音乐为主题的地标性城市公园——成都露天音乐公园、西部地区规模最大的现代主题公园——华侨城欢乐谷、全省最大的园林别墅式宾馆——金牛国宾馆、成都主城区容纳观众人数最多的国际体育赛事场馆——凤凰山体育中心，是主城区自然生态最好的区域。</p>
    <h4>金牛自知征程远，不待扬鞭自奋蹄</h4>
    <p>当前，金牛区正以“提档升级、提质增效，完善功能、优质服务”为方向，努力“提升金牛品质、打造金牛品牌、重振金牛雄风”，加速打造“商贸商务强区、都市工业新区、科创服务大区”，加快成为美丽宜居公园城市的“中优提质典范区”。</p>
    `,
    popup: {
      title: "金牛区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/8/jinniu.png" class="bimg" />
      <p>打造品质住宿支持 ,对新评定的四星级、五星级旅游饭店，分别给予企业 50 万元、100 万元的一次性支持；对于晋升星级的，参照上述标准给予差额支持。对国家省市行业主管部门新评定的绿色旅游饭店、文化主题饭店、智慧酒店，均给予 10 万元一次性支持，三者不重叠支持。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "泰鑫华居",
        contact: "袁先生",
        phone: "180-3075-0826",
        img_count: 2,
        desc: `
        <h4 class="title">泰鑫华居</h4>
        <p>《泰鑫华居》建设项目是由四川泰鑫华居置业有限公司开发，总投资近 1 亿元，项目总占地面积 2934.77 平方米 , 总建筑面积为 8711.88 平方米，其中住宅建筑面积 4071.74 平方米，商业建筑面积 1039.44 平方米。</p>
        <h4>建设地点</h4>
        <p>成都市金牛区文汇里 150 号</p>
        <h4>建设工期</h4>
        <p>9 个月</p>
        <h4>投资总额</h4>
        <p>6100 万</p>
        <h4>建设条件</h4>
        <p>8600 平方米，地上 6 层，地下 2 层</p>
        <h4>合作方式</h4>
        <p>租赁</p>
        <h4>联系方式</h4>
        <p>袁先生 (180-3075-0826)</p>
        `,
      },
    ],
  },
  {
    img_count: 3, //轮播图的数量
    areaId: "longquanyi", //区域的id
    desc: `
    <h4>中国水蜜桃之乡</h4>
    <p>成都经开区（龙泉驿区）位于成都平原东缘，是成都市中心城区之一，幅员面积 557 平方公里，服务人口超过 140 万，是国家级经济技术开发区、天府新区·龙泉高端制造产业功能区、中法（成都）生态园、中德智能网联汽车示范基地所在地，2021 年第 31 届世界大学生夏季运动会开闭幕式和主要赛事的承办地。</p>
    <p>我区传承驿道、客家、古蜀文化，拥有东郊明珠龙泉湖、AAAA 级景区桃花故里、西部客家第一镇洛带古镇、国家重点文物保护单位明蜀王陵、千年古刹石经寺等众多自然和历史人文景观，一年一度的国际桃花节已成为享誉中外的盛会，也是国务院正式命名的“中国水蜜桃之乡”。</p>
    <p>成都经开区（龙泉驿区）坚持以汽车为主导产业，聚集了一汽丰田、一汽大众、东风神龙、沃尔沃等 11 家整车企业和德国博世等 300 余家零部件配套企业，是全球县域层级聚集整车最多的区域。</p>
    <p>2019 年全区实现地区生产总值 1318.88 亿元，继续保持四川省县（市、区）级行政区经济总量第一，整车产量连续 4 年过百万辆，连续 7 年入围全国综合实力百强区、排名升至第 27 位，位列全国投资潜力百强区第 35 位、全国 219 家国家级经开区第 19 位、利用外资水平进入全国国家级开发区前 10 位，落户世界级 500 强企业 67 家，被誉为是成都未来城市发展潜力最大、投资价值最高、发展最有希望的一片热土。</p>
    `,
    popup: {
      title: "龙泉驿区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/9/longquanyi.png" class="bimg" />
      <h4>龙泉驿区新达标主题客栈政策清单</h4>
      <h4>《成都市经济技术开发区（龙泉驿区）促进服务业重点领域加快发展扶持政策》、《成都市经济技术开发区（龙泉驿区）促进以休闲农业为主导的都市现代农业发展扶持政策》（龙委发【2017】13 号）</h4>
      <p>对深入挖掘田园农耕、民俗生活、农事生产等内涵，发展综合性农（林）旅互动休闲农业园区（基地）100 亩以上的项目，新评为全国乡村旅游创客示范基地及国家中医药健康旅游示范基地、省级乡村旅游创客示范基地，分别给予一次性奖励 50 万元、30 万元奖励；新评为国家、省、市级休闲农业与乡村旅游示范点、休闲农庄的分别给予一次性奖励 30 万元、20万元、10 万元；新评定为市级以上田园综合体、新达标主题客栈（精品民宿）和新评为五星级的农家乐、艺家乐、乡村酒店，分别给予一次性奖励 20 万元；新评为四星级的农家乐、艺家乐、乡村酒店分别给予一次性奖励 10 万元。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "天瑞假日酒店",
        contact: "",
        phone: "",
        img_count: 2,
        desc: `
        <h4 class="title">天瑞假日酒店</h4>
        <h4>所属区县</h4>
        <p>龙泉驿区</p>
        <h4>投资总额</h4>
        <p>150000 万元</p>
        <h4>项目签约双方</h4>
        <p>西藏天瑞实业有限公司</p>
        <h4>项目概况</h4>
        <p>打造复合商业综合体，主要包星级酒店、办公、酒店式公寓、风情商业街在内的多种业态。</p>
        `,
      },
    ],
  },
  {
    img_count: 2, //轮播图的数量
    areaId: "qingbaijiang", //区域的id
    desc: `
    <h4>“一带一路”大港区核心区</h4>
    <p>青白江区位于成都市东北部，面积 379 平方公里，辖 7 个镇（街道）、124 个行政村（社区），总人口 70 万，是成都国际铁路港和中国（四川）自由贸易试验区成都青白江铁路港片区所在地，是全国开行数量最多的中欧班列（成都）始发地，也是成都市域北部新兴增长极——“一带一路”大港区核心区。青白江区历史文化底蕴深厚，拥有弥牟三国文化古镇和城厢千年古城；产业基础实力雄厚，拥有规上工业企业 235 家；对外开放成效显著，拥有四川唯一铁路货运型国家对外开放口岸、综合保税区、国家多式联运海关监管中心、多式联运国家示范工程以及整车、肉类、粮食指定监管场地资质。</p>
    <h4>中国营商环境质量十佳区中国国际化营商环境建设示范区</h4>
    <p>近年来，我区坚持以习近平新时代中国特色社会主义思想为指导，深入学习贯彻党的十九大、习近平总书记对四川及成都工作系列重要指示精神和中央、省委、市委重大决策部署，主动融入国家、省、市发展战略，立足“陆海联运枢纽、国际化青白江”总体定位，深入实施“港口立城、产业兴城、品质优城”发展战略，全力构建“一港三城六个特色小镇”城市空间格局，经济社会持续保持良好发展态势，2019 年实现地区生产总值 526 亿元（同比增长 9.5%），先后获评全省“县域经济发展强县”，连续跻身全国综合实力百强区、全国投资潜力百强区、全国绿色发展百强区、全国科技创新百强区四大“全国
    百强”榜单，成为中国营商环境质量十佳区、中国国际化营商环境建设示范区。当前，成都铁路港经开区、综合保税区、中国（四川）自由贸易试验区成都铁路港片区、金青新彭“一带一路”大港区、国家级物流枢纽的“四区一枢纽”多重战略优势叠加，我区正围绕既定部署，主动服务全省“四向拓展、全域开放”和“一干多支、五区协同”发展大局、成都国际门户枢纽城市建设，努力为推动治蜀兴川再上新台阶、成都建设全面体现新发展理念的城市贡献更大力量！</p>
    `,
    popup: {
      title: "青白江区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/10/qingbaijiang.png" class="bimg" />
      <h4>支持城市商业综合体和星级酒店发展</h4>
      <p>对新建四星级酒店的，自评定星级之日起，前三年、后两年分别按照地方经济发展贡献的 50%、30% 给予酒店投资业主奖励。对新建五星级酒店的，自评定星级之日起，前三年、后两年分别按照地方经济发展贡献的 100%、50% 给予酒店投资业主奖励。酒店、民宿等在租金、物业上等有第一定优惠，具体根据体量和租用期限等商务条件进一步洽谈。</p>
      <p>品牌好、影响大的酒店项目可采取“一事一议”方式。</p>
      <p>成都市青白江区关于促进产业发展若干政策的通知 ( 青府发〔2018〕5 号 )。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "城厢天府文化 原真生活古镇",
        contact: "刘军",
        phone: "186-6113-0315",
        img_count: 2,
        desc: `
        <h4 class="title">城厢天府文化 原真生活古镇</h4>
        <p>城厢镇已有 1800 余年历史，自宋到清代千余年来都为金堂县原县治所在地，拥有彭家珍大将军专祠、绣川书院、文庙、武庙、明教寺觉皇殿等六处省级文物保护单位，文物点位 66 处，是全国重点镇、四川省历史文化名镇、四川省及成都市特色镇。项目总投资 27 亿元，实施范围约 1 平方公里，采取PPP 模式检核，总建筑面积约 32.55 万㎡，其中商业 16 万㎡ ，包括 2 万㎡ 文化空间。项目坚持“修旧如旧，修旧如故”，还原古镇本真生活，活化更新古镇文化，按照国家 AAAA 级旅游景区标准建设，突出“文、旅、商、城”四大特色功能，重点打造1956 文创园、千年西街、厢逢九思、风情绣
        川、蓉欧客厅六大功能组团和 4 街 32 巷 64 院落。未来的城厢古镇将是青白江地方文化展示全本、中国古县治活态读本、人文院落文商旅范本、成都近郊休闲轻度假体验样本。</p>
        <h4>建设地点</h4>
        <p>成都市青白江区城厢镇</p>
        <h4>建设工期</h4>
        <p>3 年</p>
        <h4>投资总额</h4>
        <p>27 亿</p>
        <h4>建设条件</h4>
        <p>公司负责基础设施、建筑空间等相关建设。</p>
        <h4>合作方式</h4>
        <p>特许经营、租赁等</p>
        <h4>联系方式</h4>
        <p>刘军（186-6113-0315）</p>
        `,
      },
    ],
  },
  {
    img_count: 1, //轮播图的数量
    areaId: "xindu", //区域的id
    desc: `
    <h4>天府明珠，香城宝地</h4>
    <p>新都，“古蜀三都”之一，从 2800 年前古蜀开明王朝在此建立都城，数千年“城名未改，城址未变”。</p>
    <p>新都，汇状元府第书香、满城桂蕊花香、宝光古寺佛香，素有“天府明珠，香城宝地”之美誉。辖区幅员面积 496 平方公里，有西南石油大学、四川音乐学院、成都医学院等大中专院校 12 所，服务人口 142万。地铁 3 号线、5 号线建成开通，“7 高 7 快 13 轨”建构起成都大都市圈北部中心现代交通体系。</p>
    <p>新时代的新都，致力建设全面践行新发展理念的公园城市示范区，在实施成渝地区双城经济圈战略生动实践中，践行新都使命、凸显新都优势、提升新都能级，绘就人城境业和谐发展的大美画卷。2019 年，全区实现地区生产总值 825 亿元，一般公共预算收入60.1 亿元。连续获评全国综合实力、绿色发展、投资潜力、科技创新、新型城镇化质量、政府信用 6 个“百强区”。全区共有星级酒店三家，2019 年共接待游客 1779.94 万人次，实现旅游收入 44.01 亿元。</p>
    <h4>新理念引领新跨越</h4>
    <p>坚持新思想导航，新理念引领，确立“154”总体部署，着力建设大港一体先行区、成德同城枢纽区、智造服务引领区、公园城市典范区。</p>
    <p>统筹空间、规模、产业三大结构，坚持在公园中营建城市，以 821 公里高标准生态绿道串联城乡社区，城市之肺—3000 亩泥巴沱森林公园成为生态价值转化的典范。“十里春风”集成芳华桂城、洗心箼、音乐足球小镇、尖峰旱雪运动基地等农商文旅综合体，成为乡村振兴的新都表达。<p/>
    <h4>新动能支撑新发展 新机制做强新平台</h4>
    <p>强化硬核科技支撑，促进轨道交通、航空制造等战略性新兴产业快速崛起，医药医贸、现代物流、智能家居等先导产业引领发展，机电装备、食品饮料等传统产业转型升级，电子竞技、音乐文创等新经济新业态培育成势。引培上市企业 53 家、高新技术企业109 家。</p>
    <p>新都轨道交通以中车为龙头，集聚新誉、今创等50 余家上下游配套企业，形成年产 600 辆地铁整车能力，实现 60% 以上成都地铁列车“新都造”，时速140 公里地铁车辆在新都成功研制，并积极向动车组高级修、动车组制造等领域拓展。</p>
    <p>新都航空产业充分发挥中航成飞、成发和成发涡轮研究院等头部企业旗帜效应，航空大部件核心配套企业纷纷落户，C919、ARJ21、C929 机头部段将实现新都产。</p>
    <p>新都公路物流占四川省总量的 50%，与蓉欧铁路港形成公铁联运无缝对接，集聚了安博、阿里菜鸟、德国邮政（DHL）、普洛斯、传化等一批世界级物流巨头，京东亚洲一号智能物流年处理能力破亿单。</p>
    <p>西部家具在成都，成都家具半新都。新都是全国四大家具集散地之一，坚持创意设计牵引，推动传统家具制造向智能家居一体化解决方案升级，培育了好迪、帝标、好风景等一大批有根企业。</p>
    <p>坚持“研发设计 + 现代制造 + 现代服务”联动推进，有效链接技术、资本、人才，促进 5G、工业互联网、人工智能等新技术、新产业、新模式快速兴起，新经济应用场景不断拓展。</p>
    <h4>新机制做强新平台</h4>
    <p>坚持以产业生态圈创新生态链推进经济工作组织方式转变，按照“人城产”逻辑和独立成市理念，聚焦聚力打造现代交通产业功能区、智慧物流产业园、智能家居产业城，促进企业配套链、供应链、价值链紧密合作，实现“上下楼就是上下游，功能区就是生态圈”，产业基础高级化、产业链现代化水平显著提升。创新“指挥部 + 管委会 + 平台公司”推进机制，前瞻布局人才公寓、标准厂房、活力公园，集中打造高品质科创空间，构建现代化设施平台、公共技术平台和生活性服
    务平台。坚持贴近从业群体需求规划建设生活场景、消费场景和公共服务配套，推进园区、景区、校区与产业社区有机融合，以片区开发思路建设未来城市、理想社区。</p>
    <h4>新场景赋能新消费</h4>
    <p>新都，流量枢纽，要素汇聚，氤氲市井烟火，站上时尚前沿。坚持以 TOD 综合开发重塑成北区域消费中心格局，大力发展首店经济、假日经济，打造集特色餐饮、时尚潮购、生态游憩、夜宴夜游于一体的“绿道 +”“公园 +”消费新场景，为消费者增进体验，为投资者创造空间。</p>
    <p>熊猫国际旅游度假区联动沸腾小镇、漫花庄园等网红打卡地，“熊猫 + 火锅”文化 IP 熠熠生辉，“抱着熊猫吃火锅，听着音乐去滑雪”引领消费潮流。</p>
    <h4>新都在这里。宜商宜业宜游宜居，新都欢迎您！</h4>
    `,
    popup: {
      title: "新都区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/11/xindu.png" class="bimg" />
      <p>一事一议</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "天府沸腾小镇 - 沸腾里",
        contact: "彭诚",
        phone: "15528461805",
        img_count: 2,
        desc: `
        <h4 class="title">天府沸腾小镇-沸腾里</h4>
        <h4>建设地点</h4>
        <p>四川省成都市新都区叠秀路</p>
        <h4>建设工期</h4>
        <p>2020 年底竣工</p>
        <h4>投资总额</h4>
        <p>12 亿</p>
        <h4>建设内容</h4>
        <p>沸腾里聚合“熊猫、音乐、火锅”三大成都特色元素，以火锅所代表的成都沸腾精神为文化内核，对在地文化进行潮流化、现代化演绎。熊猫为形象符号，音乐为精神表达，火锅为产业集聚，打造具有鲜明地域特色、充满年轻活力的文化休闲新场景。</p>
        <h4>合作方式</h4>
        <p>租赁 / 联营</p>
        <h4>联系方式</h4>
        <p>彭诚 15528461805</p>
        `,
      },
    ],
  },
  {
    img_count: 2, //轮播图的数量
    areaId: "wenjiang", //区域的id
    desc: `
    <p>成都中心城区的重要组成部分</p>
    <p>素有“金温江”的美誉</p>
    <p>全国休闲农业与乡村旅游示范区</p>
    <p>最美中国生态旅游目的地城市</p>
    <h4>总体情况</h4>
    <p>温江，地处天府之国腹心，幅员面积 277 平方公里，常住人口 95 万人，是成都中心城区的重要组成部分，素有“金温江”的美誉。近年来按照“全面体现新发展理念宜业宜居宜游的新中心城区”总体目标，温江正高质量建设“三医融合”产业之城、创新开发进取之城、便捷高效畅通之城、天蓝地绿亲水之城、文明和谐幸福之城。先后获得“全国休闲农业与乡村旅游示范区”“最美中国生态旅游目
    的地城市”等荣誉称号，成功入选首批国家全域旅游示范区创建单位。温江东临成都市青羊区，南与双流区连界，西与崇州市接壤，北与郫都区、都江堰市相连，距成都市中心城区 16 公里，双流国际机场 18 公里。依托地铁 4 号线、17 号线、成蒲铁路温江站，构建“三高八快七轨”综合交通体系和“东畅西联南北通”外向交通格局，30 分钟可达双流国际机场。统筹建设锦城绿道温江段等“三网
    融合”绿道 251 公里，开行接驳景区（点）的旅游巴士。</p>
    <h4>产业发展情况</h4>
    <p>2018 年 ： 全区接待游客 人次，同比上涨 7.09%，接待过夜游客 355.63 万人次，同比上涨 14.79%旅游综合收入 88.49 亿元，同比增长 17.45%</p>
    <p>2019 年上半年：全区接待游客 人次‘同比上涨 10.69%’接待过夜游客 134.82 万人次，同比上涨 7.18%，旅游综合收入 51.63 亿元，同比增长 12.04%</p>
    <p>连续三年增速超过 10%。旅游业对 GDP 的综合贡献达17.8%，旅游业对县域经济贡献巨大。</p>
    <h4>旅游 + 医学、医药、医疗</h4>
    <p>目加快集聚，华西医院、成都中医药大学等资源富集，类经堂获评中国健康产业示范基地。签约恒大·养生谷、大嘉汇·全龄康养小镇、凤凰康养文旅小镇、国寿嘉园等康养旅游项目，在全域形成医养、乐养、智养、农养、林养等康养旅游产业生态圈。</p>
    <h4>旅游 + 都市农业</h4>
    <p>全区 2000 多个川西林盘星罗棋布，17 万亩花木郁郁葱葱，鱼凫原乡获评全省首家中国农业公园，幸福田园获评中国乡村旅游模范村、省级乡村旅游创客示范基地。依托 167 平方公里生态大公园，以淼兮帐篷度假酒店、陌见民宿为代表的中高端野奢精品民宿，打造精品酒店群，引导特色客栈、乡村酒店等建设，提升北部生态旅游区住宿接待能力。</p>
    <h4>旅游 + 工业</h4>
    <p>开发扬名火锅底料、成都印钞有限公司纪念币等特色旅游产品，全面推进货币文化工业旅游园等一批工业旅游项目进程。</p>
    <h4>旅游 + 体育</h4>
    <p>成功创建国家体育产业示范基地，绿道骑行、运动健身、亲子游憩、湿地公园、水上运动等业态丰富。打出活动引流组合拳，结合金温江半程马拉松等体育赛事配套活动，将赛事向全域旅游延伸。CBA 赛事中心建设，完成鲁家滩体育公园和 30 条全民健身路径、5 个全民健身室建设。</p>
    <h4>旅游＋文创</h4>
    <p>“西行智驾·成都旅游创新实验室”建成投运，成都新光影视文旅城顺利奠基，珠江“集合”特色商业街完成打造，国色天乡商业街改造升级，已形成温江绿道统一 VI（公共视觉识别）系统。</p>
    <h4>项目资源情况</h4>
    <p>近年，大力推进重大文化旅游项目 38 个，国色天乡、西行起点等规模以上文化和旅游企业达 228 家，2016年至2018 年，分别完成重大涉旅项目投资 13.42、9.6和 9.42 亿元。成立旅投国有平台公司，高效对接市场。2018 年，旅游相关行业税收占全区税收 14.12%，旅游就业人数占全区就业人数 18.78%。</p>
    <p>全区旅游要素丰富，万春卤菜等 20 余个温江美食“老字号”声名远扬，柏萃等 814 个农家乐、乡村餐饮遍地开花。皇冠假日酒店等 500 余家酒店群星璀璨，淼兮帐篷度假酒店等高端民宿品质卓越，全区床位达 1.97万张。珠江广场、星光天地等 10 余个高端购物综合体人气旺盛，川派盆景等 30 余种旅游商品特色突出。鱼凫传奇、尖叫大马戏等演艺丰富多彩。</p>
    <h4>品牌资源情况</h4>
    <p>资源品牌</p>
    <p>获评国际花园城市、联合国杰出绿色生态城市等世界级品牌，获评金马湖省级水利风景区，拥有重点文物保护单位 15 处（鱼凫村遗址、陈家大院为国家级），蛾蛾灯等非物质文化遗产 17 项。</p>
    <p>产品品牌</p>
    <p>成功打造国家 A 级旅游景区 5 个（国色天乡、幸福田园为 4A 级），成功创建万春—国色天乡省级旅游度假区、寿安西村省级生态旅游示范区，温江绿道获评国家健身步道示范工程。</p>
    <p>品牌形象</p>
    <p>围绕“成都金温江 健康花园城”品牌，举办成都迪拜国际杯赛马经典赛、中国马术节、半程马拉松、西行起点旅博会、国际玫瑰节等特色活动每年 20 余次，开通抖音、微信等官方号，粉丝达 3 万余人，“温江旅游”新媒体获评全省旅游系统政务新媒体影响力 TOP10。</p>
    <p>荣誉称号</p>
    <p>获得国家休闲农业与乡村旅游示范区、国家体育产业示范基地、全国卫生城市、国家生态文明建设示范区、四川省旅游强县等殊荣，连续 7 年跻身“中国综合实力百强区”，连续 21 年位列全省经济综合评价“十强县”。</p>
    `,
    popup: {
      title: "温江区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/12/wenjiang.png" class="bimg" />
      <h4>成都市温江区促进全域旅游发展的若干政策措施</h4>
      <h4>发展乡村旅游，助力乡村振兴</h4>
      <p>1. 对新评定为国家级、省级乡村旅游创客示范基地的分别给予 20 万元、10 万元一次性奖励；新评定为全国休闲农业与乡村旅游示范点的，给予 50 万元一次性奖励；新评定为成都市主题旅游目的地的，给予20 万元一次性奖励；新评定为旅游特色小镇，给予 50万元一次性奖励 ; 新达标的主题客栈（精品民宿），给予 5 万元一次性奖励。</p>
      <p>2. 推进乡村酒店、农家乐“四改一提升”（改厨、改厕、改餐、改客房和提升服务）和环保配套，对取得一定效果的乡村酒店、农家乐等实施主体，按建设经费的 30% 给予不超过 50 万元一次性补助。</p>
      <h4>鼓励文创旅游，推进产业升级</h4>
      <p>1. 培育旅游产业新业态，加大与文创、会展、体育、科技、工业等融合发展，对形成旅游产品的，经认定，根据实际贡献和效果，按项目建设经费的 30% 给予旅游企业不超过 100 万元补助。围绕旅游体验、旅游管理、旅游服务和旅游营销，对建设智慧旅游公共服务平台，辐射带动作用明显的，经认定，按项目建设经费的 30% 给予不超过 50 万元补助。对新达到成都市智慧旅游标准的景区、饭店、旅行社，分别给予 50 万元、30 万元、10 万元一次性奖励。</p>
      <p>2. 对在政策有效期内新注册并实缴资本 200 万元以上，年度地方实际贡献 30 万元以上的文化创意旅游企业，经认定后自纳税之日起连续 3 年，按照年度地方实际贡献的 100%、80%、50% 给予奖励，单年奖励不超过 50 万元。上述受奖企业在温江区租赁办公用房的，给予一次性租房补贴，按不超过 30 元 / 月 / 平方米，在 500 平方米内据实补贴，最多补贴时限两年（24个月）。</p>
      <h4>强化营销宣传，提升区域形象</h4>
      <p>1. 鼓励各镇（街）、社会组织、旅游企业开展旅游节会活动，对承接国家、省、市、区政府或相关部门主办的旅游节会活动，对温江区全域旅游形象起到积极宣传推广作用的，根据其绩效，对承办单位给予不超过 50 万元一次性奖励。</p>
      <p>2. 鼓励旅游企业、社会组织开展线路包装、旅游文创品开发等，对温江区全域旅游形象起到积极宣传推广作用的，视其绩效，给予不超过 20 万元一次性奖励。</p>
      <p>3. 对小微旅游企业创新提升旅游产品、更新改造、转型升级等方面给予贷款贴息支持，按照同期银行基准利率，给予企业贷款利息 50% 的补贴，贴息金额不超过 100 万元；对获得专业股权投资机构 100 万元（含）以上股权投资的旅游企业，按实际股权融资额的 5%给予奖励，单笔股权融资奖励不超过 100 万元。</p>
      <h4>支持品牌创建，推动产品升级：</h4>
      <p>1. 鼓励餐饮、住宿企业开展品牌创建。对新评定的五星级、四星级、三星级酒店，分别给予 100 万元、50 万元、30 万元一次性奖励，升级的酒店按级别差额补足。复核通过的五星级、四星级、三星级酒店分别给予30 万元、20 万元、10 万元一次性奖励。鼓励新评定的五星级、四星级、三星级乡村酒店（农家乐），分别给予 50 万元、30 万元、20 万元一次性奖励，升级的乡村酒店（农家乐）按级别差额补足。复核通过的五星级、四星级、三星级乡村酒店（农家
      乐），分别给予 10 万元、5 万元、3 万元一次性奖励。新评定的金叶级、银叶级绿色旅游饭店，新评定的金鼎级、银鼎级文化主题旅游饭店，新评定的金宿级、银宿级旅游民宿，按评定级别分别给予 50 万元、30 万元一次性奖励。新评定的精品旅游饭店，给予50 万元一次性奖励。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "和林荷园",
        contact: "",
        phone: "",
        img_count: 2,
        desc: `
        <h4 class="title">和林荷园</h4>
        <h4>所属区（市）县</h4>
        <p>温江区</p>
        <h4>投资总额</h4>
        <p>14000 万元</p>
        <h4>项目签约三方</h4>
        <p>成都市温江区万春镇和林村一组股份经济合作社、成都和林荷院文化旅游资源开发有限公司</p>
        <h4>项目简介</h4>
        <p>占地 70 亩（其中集体建设用地 13 亩），拟投资14000 万元，以打造川西生态休闲度假庄园为核心，集休闲娱乐和颐养小院为一体的文化旅游消费场景，项目按照“一核两带三片”规划布局（一核：荷塘，两带：网红休闲绿带、生态养生绿带，三片：博览民宿馆、音乐荷塘岸、颐养小院），建筑面积 10004 平方米，打造“吃、住、游、娱、学”为一体文化休闲旅游圣地。</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "一岚花集民宿",
        contact: "",
        phone: "",
        img_count: 3,
        desc: `
        <h4 class="title">一岚花集民宿</h4>
        <h4>所属区（市）县</h4>
        <p>成都市温江区寿安镇天星村</p>
        <h4>投资总额</h4>
        <p>3500万元</p>
        <h4>项目签约三方</h4>
        <p>成都市温江区生态旅游区管委会、成都市温江区寿安镇人民政府、成都一岚文化旅游开发有限公司</p>
        <h4>项目概况</h4>
        <p>一岚花集民宿位于成都市温江区寿安镇植物编艺公园内，距离成都市区半小时车程，区域内环境优美、植物种类丰富，是植物编艺工艺的主要在地呈现区。一岚花集民宿定位于生活美学体验与社交学习型民宿聚落，构建有质量、有温度、有情怀的社群。主要对象为成都市中产阶级，面向需求包括亲子社交、自我疗愈、成长学习以及行业交流。一岚花集民宿整体占地约 14.5 亩
        ，其中集体建设用地 5.99 亩，农用地 8.5 亩。包括民宿聚落、社交空间、美学花园、大地餐厅等主要业态。其中民宿客房约 30 个，具备茶室、共享厨房、花园会议室等功能的公共社交空间约 500 ㎡，大地餐厅系统约 3 亩，美学花园生态圈约 5 亩。项目预计在 2021 年 12 月启动试营业，未来预计年运营收入约 505 万元。</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "田园总部办公基地",
        contact: "",
        phone: "",
        img_count: 2,
        desc: `
        <h4 class="title">田园总部办公基地</h4>
        <h4>所属区（市）县</h4>
        <p>温江区</p>
        <h4>投资总额</h4>
        <p>10000 万元</p>
        <h4>项目签约三方</h4>
        <p>四川翔韵建筑劳务有限公司、温江区万春镇人民政府</p>
        <h4>项目概况</h4>
        <p>项目占地面积 30 亩（其中集体建设用地 6 亩），规划用地面积 3980 平方米，总投资5000 万元，拟建设综合服务大厅、办公总部、庭院景观、精品民宿、商务中心，实现田园基地、办公总部、企业培训、创业孵化、服务管理等功能，建设一个极具田园特色，集企业总部办公，创新孵化、田园度假、配套服务等为一体的生产、生活、生态融合型企业聚集地。</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "依田桃源",
        address: "温江区万春镇鱼凫村、报恩村",
        yusuan: "500000 万元",
        img_count: 2,
        desc: `
        <h4 class="title">依田桃源</h4>
        <h4>建设地点</h4>
        <p>温江区万春镇鱼凫村、报恩村</p>
        <h4>投资总额</h4>
        <p>500000 万元</p>
        <h4>项目建设单位</h4>
        <p>成都明信房地产集团有限公司</p>
        <h4>项目概况</h4>
        <p>项目位于鱼凫村、报恩村，占地约 2000 亩，一期用地约 850 亩。按国家 AAAAA 级标准打造集现代有机农业、花果观赏、文化创意、乡村酒店、健身康养于一体的现代都市农业旅游景区、园林生态“两养”度假胜地，致力于成为中国新农村建设的典范和开创者。</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "槿篱·花溪",
        contact: "黄筱璐",
        phone: "186-2818-0314",
        img_count: 2,
        desc: `
        <h4 class="title">槿篱·花溪</h4>
        <h4>建设地点</h4>
        <p>温江区 4A 级景区幸福田园内</p>
        <h4>建设工期</h4>
        <p>2019 年 9 月开工建设，预计 2021 年 11 月完工。</p>
        <h4>投资总额</h4>
        <p>10000 万元</p>
        <h4>建设内容</h4>
        <p>项目占地约 80 亩，其中建设用地 35.35 亩，规划总建筑面积约 21112.14 ㎡，拟建温泉主题酒店、商业街区、民宿群落。</p>
        <h4>建设条件</h4>
        <p>装配率≥ 20%，绿色建筑等级≥ 1 星。</p>
        <h4>合作方式</h4>
        <p>项目已开工建设，计划招引管理经营运营商或出租、出售方。</p>
        <h4>联系方式</h4>
        <p>黄筱璐（186-2818-0314）</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "悠然·半亩方塘民宿酒店",
        contact: "林文秀",
        phone: "183-0288-8408",
        img_count: 1,
        desc: `
        <h4 class="title">悠然·半亩方塘民宿酒店</h4>
        <h4>建设地点</h4>
        <p>温江区幸福田园 4A 景区核心区（万春镇幸福村八组）</p>
        <h4>建设工期</h4>
        <p>2018 年 8 月开工建设，已于 2019 年 11 月完工，试运营中。</p>
        <h4>投资总额</h4>
        <p>9000 万元 </p>
        <h4>建设内容</h4>
        <p>整体占地约 40 亩，其中建设用地约 8.2 亩（5453 ㎡），预计投资约 9000 万元，规划总建筑面积约 6858.11 ㎡，共计建筑 6 栋，包括 4 栋新建产业建筑，1 栋新建公共服务设施建筑，1 栋保留建筑，共有客房 23 间。</p>
        <h4>合作方式</h4>
        <p>计划招引管理经营运营商或出租、出售方。</p>
        <h4>联系方式</h4>
        <p>林文秀（183-0288-8408）</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "玉河花海",
        lianxifang: "温江区和盛镇",
        phone: "028-82771017",
        img_count: 1,
        desc: `
        <h4 class="title">玉河花海</h4>
        <h4>建设地点</h4>
        <p>成都市温江区和盛镇玉河村 2 组</p>
        <h4>建设工期</h4>
        <p>待定</p>
        <h4>投资总额</h4>
        <p>待定</p>
        <h4>建设内容</h4>
        <p>计划招引企业建设乡村酒店、特色民宿、文创旅游综合体项目。</p>
        <h4>建设条件</h4>
        <p>地块面积 13.5 亩，容积率≦ 21.5</p>
        <h4>合作方式</h4>
        <p>待定</p>
        <h4>联系方式</h4>
        <p>温江区和盛镇 028-82771017</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "渡桥田园综合体",
        lianxifang: "温江区和盛镇",
        phone: "028-82771017",
        img_count: 1,
        desc: `
        <h4 class="title">渡桥田园综合体</h4>
        <h4>建设地点</h4>
        <p>成都市温江区和盛镇渡桥村 8 组</p>
        <h4>建设工期</h4>
        <p>待定</p>
        <h4>投资总额</h4>
        <p>待定</p>
        <h4>建设内容</h4>
        <p>计划招引企业建设以“川西民居”为主题，打造休闲、民宿、乡村酒店为一体的农业观光旅游示范项目。</p>
        <h4>建设条件</h4>
        <p>地块面积 16 亩，容积率小于等于 21.5</p>
        <h4>合作方式</h4>
        <p>待定</p>
        <h4>联系方式</h4>
        <p>温江区和盛镇 028-82771017</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "舒家渡文旅项目",
        lianxifang: "温江区和盛镇",
        phone: "028-82771017",
        img_count: 2,
        desc: `
        <h4 class="title">舒家渡文旅项目</h4>
        <h4>建设地点</h4>
        <p>计划招引企业建设乡村酒店、特色民宿、文创旅游综合体项目。成都市温江区和盛镇社区</p>
        <h4>建设工期</h4>
        <p>待定</p>
        <h4>投资总额</h4>
        <p>待定</p>
        <h4>建设内容</h4>
        <p>计划招引企业建设乡村酒店、特色民宿、文创旅游综合体项目。</p>
        <h4>建设条件</h4>
        <p>地块面积 119 亩</p>
        <h4>合作方式</h4>
        <p>待定</p>
        <h4>联系方式</h4>
        <p>温江区和盛镇 028-82771017</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "东宫寺综合体",
        lianxifang: "温江区和盛镇",
        phone: "028-82771017",
        img_count: 2,
        desc: `
        <h4 class="title">东宫寺综合体</h4>
        <h4>建设地点</h4>
        <p>计划招引企业建设乡村酒店、特色民宿、文创旅游综合体项目。</p>
        <h4>建设工期</h4>
        <p>待定</p>
        <h4>投资总额</h4>
        <p>待定</p>
        <h4>建设内容</h4>
        <p>计划招引企业建设乡村酒店、特色民宿、文创旅游综合体项目。</p>
        <h4>建设条件</h4>
        <p>地块面积 42.56 亩，容积率≦ 2.0,建筑高度 11 层、17 层。</p>
        <h4>合作方式</h4>
        <p>待定</p>
        <h4>联系方式</h4>
        <p>温江区和盛镇 028-82771017</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "日香湖农旅项目",
        lianxifang: "温江区和盛镇",
        phone: "028-82771017",
        img_count: 2,
        desc: `
        <h4 class="title">日香湖农旅项目</h4>
        <h4>建设地点</h4>
        <p>成都市温江区和盛镇，友庆社区 7 组</p>
        <h4>建设工期</h4>
        <p>待定</p>
        <h4>投资总额</h4>
        <p>待定</p>
        <h4>建设内容</h4>
        <p>计划招引企业建设以观光为主题的乡村酒店</p>
        <h4>建设条件</h4>
        <p>地块面积 37.75 亩，容积率≦ 0.9 建筑密度≦ 30%。绿地率≧ 30%，建筑高度≤ 3F。</p>
        <h4>合作方式</h4>
        <p>待定</p>
        <h4>联系方式</h4>
        <p>温江区和盛镇 028-82771017</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "兰亭社区农养农创综合项目",
        lianxifang: "温江区和盛镇",
        phone: "028-82771017",
        img_count: 1,
        desc: `
        <h4 class="title">兰亭社区农养农创综合项目</h4>
        <h4>建设地点</h4>
        <p>成都市温江区和盛镇友庆社区（原铁篱村 2、3、4、6 组）</p>
        <h4>建设工期</h4>
        <p>待定</p>
        <h4>投资总额</h4>
        <p>待定</p>
        <h4>建设内容</h4>
        <p>计划招引企业建设特色民宿、农创农旅农养综合体项目。</p>
        <h4>建设条件</h4>
        <p>地块面积 125.03 亩，容积率≦ 0.9，建筑密度≦ 30%，绿地率≧ 30%，建筑高度≤ 3F。</p>
        <h4>合作方式</h4>
        <p>待定</p>
        <h4>联系方式</h4>
        <p>温江区和盛镇 028-82771017</p>
        `,
      },
       {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "玉河村农养创综合项目",
        lianxifang: "温江区和盛镇",
        phone: "028-82771017",
        img_count: 1,
        desc: `
        <h4 class="title">玉河村农养创综合项目</h4>
        <h4>建设地点</h4>
        <p>成都市温江区和盛镇綦临社区（原临江村 1、2、3 组）</p>
        <h4>建设工期</h4>
        <p>待定</p>
        <h4>投资总额</h4>
        <p>待定</p>
        <h4>建设内容</h4>
        <p>计划招引企业建设特色民宿、乡村酒店、农创农旅农养综合体项目。</p>
        <h4>建设条件</h4>
        <p>地块面积 100.4 亩，产业容积率≦ 1.5，居住容积率≦ 1.2。</p>
        <h4>合作方式</h4>
        <p>待定</p>
        <h4>联系方式</h4>
        <p>温江区和盛镇 028-82771017</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "綦临农养农创综合项目",
        lianxifang: "温江区和盛镇",
        phone: "028-82771017",
        img_count: 1,
        desc: `
        <h4 class="title">綦临农养农创综合项目</h4>
        <h4>建设地点</h4>
        <p>成都市温江区和盛镇綦临社区（原临江村 1、2、3 组）</p>
        <h4>建设工期</h4>
        <p>待定</p>
        <h4>投资总额</h4>
        <p>待定</p>
        <h4>建设内容</h4>
        <p>计划招引企业建设特色民宿、乡村酒店、农创农旅农养综合体项目。</p>
        <h4>建设条件</h4>
        <p>地块面积 100.4 亩，产业容积率≦ 1.5，居住容积率≦ 1.2。</p>
        <h4>合作方式</h4>
        <p>待定</p>
        <h4>联系方式</h4>
        <p>温江区和盛镇 028-82771017</p>
        `,
        },
    ],
  },
  {
    img_count: 3, //轮播图的数量
    areaId: "shuangliu", //区域的id
    desc: `
    <p>“带二江之双流，抗峨眉之重阻”，左思一首《蜀都赋》，为双流赋予美名。双流位于成都市南面，是成都市的中心城区，是双流国际机场的所在地。全区实际管辖面积 466 平方公里、服务人口 150 万，2019年实现地区生产总值 962 亿元、增长 8.8%，可支配财力 207.88 亿元，在全国百强区排名中，位列第 32位。目前全区拥有 4A 级景区 2 个，高星级及精品酒店 30 余家，2019 年接待游客 1609.4 万人次、过夜游客 560 万人次。双流是国家级临空经济示范区、国家级自由贸易试验区和天府新区的重要承载地，航空经济、电子信息、生物医药是双流“三大”主导产业。而文旅，是我们的特色优势产业。</p>
    <p>双流，是古蜀文明的发源地。四千多年前，古蜀王蚕丛定都矍上教民农桑；三国时，诸葛亮屯兵牧马山指点山；川西夫子刘沅开创槐轩学说，杨柳湖畔悠悠茶香，依稀还有那朗朗的书声。双流，是天府文化的重要传承地。在人口结构中，40 岁以下的占75.3%。双流有 10 万航空从业人员，有 10 万在校本科生，年轻、青春和活力，是这个城市独特的气质。在文旅发展中，双流人文荟萃、自然生态，是成都承接大型文旅活动和国际赛事最多的区县。2019 年举办的世警会，我们把赛事与文旅融合，推出了世界警察畅游黄龙溪、海滨城新警察故事等活动，展现了四川之美、文旅之美，大体联主席拉瑞盛赞“这是办得最
    好的一届世警会”。双流，是天府旅游第一门户。双流国际机场是全国第四大航空枢纽，在全球机场中位列第 24 位，年旅客客流量 5500 多万人次，出入境旅客 700 万人次，航线通达五大洲 200 余个城市，世界的游客和商品在这里流动，文旅发展的人、货、场在这里汇聚！千年古镇黄龙溪，“日有千人拱手，夜有万盏明灯 "，与华侨城联合打造的“十里八湾 " 文旅项目全面推进，“欢乐田园”获评全省十大文旅新地标，年接待游客 800 万人次；海滨城创下“全球最大海洋观景窗”吉尼斯纪录、年接待游客 500 万人次；而在机场跑道端头打造的 1.3 万亩的空港花田，是一个抬头看飞机、低头观花海、心中想着诗
    与远方的“网红打卡地”，牧马山国际旅游区初步成型。</p>
    <h4>改革的双流，快速发展；</h4>
    <h4>开放的双流，国际时尚。</h4>
    `,
    popup: {
      title: "双流区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/13/shuangliu.png" class="bimg" />
      <h4>高质量推进成都国际空港商务区起步区建设若干政策（试行）</h4>
      <p>为充分发挥成都双流国际机场航空门户枢纽优势，鼓励和引导社会资本以多种形式参与成都国际空港商务区起步区（以下简称“起步区”）建设，高质量建设国家级临空经济示范区，加快打造中国航空经济之都，结合我区实际，制定本政策。本政策适用于起步区内（北临文昌路，西靠星空路，南至机场，东到绕城高速绿化带，规划总面积 8.06平方公里）从事开发建设、经营活动且符合相关条件的企业和社会组织。申报本政策支持的项目应具备以下条件：<br/>
符合起步区功能定位、产业发展、规划布局和开发建设要求。企业工商注册、税收解缴和统计关系均在双流区实际管辖范围内。经认定的其他项目。支持引进高端国际酒店。起步区内新建的固定资产投资额 5 亿元以上的前两家五星级以上国际品牌酒店或同等标准高品质特色酒店，优先满足其第一选址要求，优先安排建设用地指标，依法予以供地，在项目正式运营并经评定后给予 1000万元的奖励；新引进世界知名酒店管理公司前 20 强管理运营的，开业运营后给予酒店业主方 300 万元一次性奖励，获评五星级酒店后给予酒店管理方 500 万元一次性奖励</p>
      <div class="rfu"><p class="xright">（责任单位：区文化体育和旅游局）</p></div>
      <p>支持现有酒店改造升级。鼓励现有酒店实施改扩建，提升酒店品质和服务功能。对改建、扩建酒店项目的投资方，新评定为五星级、四星级、三星级酒店的分别给予 500 万元、300 万元、200 万元奖励；新评定的全国金鼎级、
银鼎级主题饭店，按评定级别分别给予 300 万元、200 万元奖励；新评定的全国金叶级、银叶级绿色饭店，按评定级别分别给予 150 万元、100 万元奖励。上述奖励在项目正式运营且获评后一次性兑现。</p>
      <div class="rfu"><p class="xright">（责任单位：区文化体育和旅游局）</p></div>
      <p>加大酒店营运支持。投运之日起前 3 年内，年平均入住率达 75% 以上且年纳税额达 300 万元以上的四星级及以上酒店，参照其当年区级实际贡献的100% 给予酒店实际运营团队营运奖励。奖励于次年兑付。</p>
      <div class="rfu"><p class="xright">（责任单位：区文化体育和旅游局）</p></div>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "空港花田",
        contact: "张佳",
        phone: "15882323018",
        img_count: 2,
        desc: `
        <h4 class="title">空港花田</h4>
        <h4>建设地点</h4>
        <p>四川省成都市双流区黄水镇、黄甲街道</p>
        <h4>建设工期</h4>
        <p>2025 年底竣工</p>
        <h4>投资总额</h4>
        <p>20 亿</p>
        <h4>建设条件</h4>
        <p>重点打造特色农业、卫星候机厅、航空文化展示中心、航域观光、野奢旅游、乡村民宿、品牌餐饮、户外运动、康养休闲等产业形态。</p>
        <h4>合作方式</h4>
        <p>合资、独资</p>
        <h4>联系方式</h4>
        <p>张佳 15882323018</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "国际空港商务区",
        contact: "张佳",
        phone: "15882323018",
        img_count: 3,
        desc: `
        <h4 class="title">国际空港商务区</h4>
        <h4>建设地点</h4>
        <p>四川省成都市双流区东升街道、西航港街道</p>
        <h4>建设工期</h4>
        <p>2030 年底竣工</p>
        <h4>投资总额</h4>
        <p>待定</p>
        <h4>建设内容</h4>
        <p>包括“一港四区”（“一港”即国际航空港，“四区”即以总部经济、商务会展为主的 11km2空港商务区起步区，以跨境贸易、体验零售为主的 0.54km2 空港滨水商务区，以品质生活、文创旅游为主的 5.88km2 空港商务服务社区，以临空商务、时尚休闲为主的 3.6km2 空港商务区拓展区）。在 0.54km2 空港滨水商业区，有商业用地 22.19 公顷，公园绿地 13.51 公顷，商业建筑体量 65 万 m2，正大力开展跨域商业、文化体验、特色酒店、购物休闲等业态引进。</p>
        <h4>合作方式</h4>
        <p>合资、独资</p>
        <h4>联系方式</h4>
        <p>张佳 15882323018</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "黄龙溪古镇打造",
        contact: "张佳",
        phone: "15882323018",
        img_count: 2,
        desc: `
        <h4 class="title">黄龙溪古镇打造</h4>
        <h4>建设地点</h4>
        <p>四川省成都市双流区黄龙溪镇</p>
        <h4>建设工期</h4>
        <p>2025 年底竣工</p>
        <h4>投资总额</h4>
        <p>待定</p>
        <h4>建设内容</h4>
        <p>主题酒店、精品民宿、康养度假、艺术设计师 / 机构、休闲观光、特色餐饮等。</p>
        <h4>合作方式</h4>
        <p>合资、独资</p>
        <h4>联系方式</h4>
        <p>张佳 15882323018</p>
        `,
      },
    ],
  },
  {
    img_count: 3, //轮播图的数量
    areaId: "pidu", //区域的id
    desc: `
    <p>郫都区，隶属于四川省成都市，位于成都市西北部，东北与彭州市、新都区，东南与金牛区毗邻，南面与青羊区相连，西南与温江区、西北与都江堰市接壤。是四川农家乐旅游发源地，有豆瓣之乡、蜀绣之乡、盆景之乡之称；是四川省成都市以建设国家中心城市为目标重点打造的“电子信息和双创产业基地、国际化都市新区”。</p>
    <p>郫都区辖幅员面积 438 平方公里，辖 9 个街道、3 个镇委托成都高新区管理 2 个街道，43 平方公里；境内地处都江堰自流灌区之首，居四川成都上风上水；承担成都市区 90% 以上饮用水供水任务。地势平坦，土地肥沃，柏条河等 8 河并流，造就“水旱从人，时无饥馑”的自然禀赋。属亚热带季风性湿润气候，夏无酷暑，
    冬无严寒，雨量充沛。2019 年末，常住人口 86.57 万，该区地区生产总值 631.9 亿元。</p>
    <p郫都区因“杜宇化鹃”传说，而称鹃城，既是望帝杜宇、丛帝鳖灵建都立国之地，又是古蜀文明发祥地；公元前 314 年，秦灭蜀后，以郫邑为郡县，称郫县。造就出鹃城遗址、古城遗址、唐昌文庙等历史遗迹，望丛祠世界蜀人祭祖圣地等。孕育严君平、扬雄、何武、张俞等历史名人。“郫筒酒”，“郫县豆瓣”，“郫县女红”等郫都区工艺三绝。</p>
    <p>郫都区境内有西南交通大学、电子科大等大中专院校 19 所，国家级实验室 31 个；拥有成都地铁 2 号线、成都地铁 6 号线，成都有轨电车蓉 2 号线，成灌快铁，成都市四环路、成灌高速、317 国道、沙西线、IT 大道、温彭快速通道等交通线。2018 年全国科技创新百强区。</p>
    `,
    popup: {
      title: "郫都区旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/14/pidu.png" class="bimg" />
      <p>一、鼓励企业创“星”。对新评为五星级、四星级饭店的，分别给予 50 万元、30 万元的一次性奖励；对新评为五星级、四星级农家乐（乡村饭店、旅游民宿）的，分别给予 30 万元、20 万元的一次性补贴。</p>
      <p>二、对新评为成都智慧旅游景区、饭店、旅行社的，给予 10 万元、5 万元、5 万元的一次性奖励。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "望丛天府文化产业园项目",
        contact: "王雪琴、郭雨桥",
        phone: "028-86553097",
        img_count: 1,
        desc: `
        <h4 class="title">望丛天府文化产业园项目</h4>
        <h4>建设地点</h4>
        <p>郫都区郫筒街道</p>
        <h4>建设工期</h4>
        <p>约5年</p>
        <h4>投资总额</h4>
        <p>200 亿元</p>
        <h4>建设内容</h4>
        <p>围绕望丛祠改造提升，以望丛博物馆建设心以望丛公园为纽带 , 结合“公园城市和三城三都”建设，充分挖掘古蜀望丛文化历史文脉，运用城市综合开发理念和 TOD 模式，打造集文创、商务、旅游、酒店等为一体的泛文博新经济驱动发展的多元体验文化新城和新消费场景，建设城市新地标。</p>
        <h4>建设条件</h4>
        <p>项目区域有成灌铁路、轨道 2 号线、轨道 6号线、有轨电车 2 号线，与成都市中心和都江堰联系便捷；项目区域周边商业、医疗、教育等配套设施齐全 。</p>
        <h4>合作方式</h4>
        <p>独资或合资</p>
        <h4>联系方式</h4>
        <p>王雪琴、郭雨桥 电话：028-86553097</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "文旅创意空间项目",
        contact: "王雪琴、郭雨桥",
        phone: "028-86553097",
        img_count: 1,
        desc: `
        <h4 class="title">文旅创意空间项目</h4>
        <h4>建设地点</h4>
        <p>郫都区友爱镇</p>
        <h4>建设工期</h4>
        <p>约3年</p>
        <h4>投资总额</h4>
        <p>50 亿元</p>
        <h4>建设内容</h4>
        <p>拟建文化旅游、乡村度假目的地、主题酒店、商业配套等，营造让消费者乐于融入的 IP 场景氛围，打造郫都创意 IP。</p>
        <h4>建设条件</h4>
        <p>该项目附近有国家“AAAA”级旅游景区农科村，子云廊园、耕耘桥、农耕文化园等景点，刘氏庄园、竹里湾、徐家大院、三元居等 40余户农家旅游接待点，商业配套成熟。</p>
        <h4>合作方式</h4>
        <p>独资或合资</p>
        <h4>联系方式</h4>
        <p>王雪琴、郭雨桥 电话：028-86553097</p>
        `,
      },
    ],
  },
  {
    img_count: 2, //轮播图的数量
    areaId: "jianyang", //区域的id
    desc: `
    <p>简阳位于四川盆地西部、成都东南，素有“天府雄州”之美誉，全市面积 1345 平方公里，辖 7个街道、15 个镇，总人口 93.6 万（不含成都东部新区）。当前，成都市正在深入实施“东进”战略，将全面推进城市东扩、重心东移、产业东聚，把更多优质资源要素集中投向“东进”区域。简阳是实施“东进”战略的主战场、主阵地，在成都市“东进”战略规划中，简阳
    城区定位为成都东部城市新区综合服务基地、智能制造基地、现代物流基地、“城山相映、人水共生”的活力文明城市。规划至 2035 年，城市建成区面积达 50 平方公里，人口达 50 万；至2050 年，城市建成区面积达 100 平方公里，人口达100 万。</p>
    <p>截至目前，<br/>
    全市有星级酒店 1 家，<br/>
    绿色饭店 2 家，<br/>
    主题旅游客栈 1 家，<br/>
    成都市 3A 级林盘景区 2 个，<br/>
    “新旅游·潮成都”主题旅游目的地 4 个，<br/>
    农家乐 / 乡村酒店 64 家（其中省星级农家乐 / 乡村酒店 11 家）;<br/>
    旅行社分支机构 42 家，旅游商品 30 余种；<br/>
    四川省乡村旅游示范村 1 个，<br/>
    四川省乡村旅游特色业态 3 个，<br/>
    省级旅游扶贫示范村 1 个；<br/>
    重要旅游节庆活动 1 个。</p>
    `,
    popup: {
      title: "简阳市旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/15/jianyang.png" class="bimg" />
      <p>对新评定的五星级、四星级、三星级酒店，分别给予 200 万元、100 万元、30 万元的一次性奖励；新评定的金树叶级、银树叶级绿色旅游饭店，新评定的金鼎级、银鼎级文化主题旅游饭店，新评定的金宿级、银宿级旅游民宿，新评定的金芙蓉级、银芙蓉级主题旅游客栈，按评定级别分别给予 50 万元、30 万元的一次性奖励；新评定的精品旅游饭店，给予 50 万元的一次性奖励。
      升级的酒店按级别差额补足；通过复核的五星级、四星级、三星级酒店，分别给予 20 万元、10 万元、5 万元的一次性奖励；通过复核的绿色旅游饭店、文化主题旅游饭店、旅游民宿、精品旅游饭店，分别给予 5 万元的一次性奖励。引进全球或中国知名酒店管理集团（经世界旅游组织和国家旅游局认定）进行经营管理，且管理期满 2 年以上的旅游酒店，对酒店业主给予一次性奖励 
      50 万元；使用知名酒店品牌，且管理期满 2 年以上的旅游酒店，对酒店业主给予一次性奖励 20 万元。新引进知名品牌连锁酒店管理公司对我市乡村酒店、农家乐进行管理且年满 1 年以上的，对酒店业主给予一次性奖励 50 万元</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "家风荷乡景区民宿聚落",
        contact: "邱晓君",
        phone: "028-27028321",
        img_count: 2,
        desc: `
        <h4 class="title">家风荷乡景区民宿聚落</h4>
        <p>家风荷乡景区民宿聚落是以特色民宿加家风文化的模式发展的微度假旅游目的地，在不破坏林盘生态环境的基础上，引入特色的小木屋、树屋等生态创意建筑形式，结合国际先进的低碳环保度假酒店模式植入休闲、
娱乐、住宿等功能，打造野奢、生态的森林度假酒店，同时把中华传统文化如家风文化、汉服文化、宗祠文化等融入经营，打造成融旅游观光、文化体验、休闲住宿为一体的特色旅游目的地。</p>
        <h4>建设地点</h4>
        <p>简阳市平泉街道荷桥村</p>
        <h4>建设工期</h4>
        <p>2 年</p>
        <h4>投资总额</h4>
        <p>8000 万</p>
        <h4>建设条件</h4>
        <p>民宿聚落选址于简阳市家风荷乡景区内，该景区围绕“中华家风园”定位，规划打造国家 4A级景区，建成天府之旅第一站，巴蜀文化旅游走廊新亮点，景区毗邻成都经济区环线高速公路出口，邻近渝蓉高速公路、国道 318。该项目选址景区核心区，生态环境、用地条件俱佳，区位优势明显。</p>
        <h4>合作方式</h4>
        <p>独资或合资</p>
        <h4>联系方式</h4>
        <p>邱晓君（028-27028321）</p>
        `,
      },
    ],
  },
  {
    img_count: 3, //轮播图的数量
    areaId: "dujiangyan", //区域的id
    desc: `
    <h4>“拜水都江堰，问道青城山”</h4>
    <p>因都江堰水利工程而得名的都江堰市，是世界文化遗产青城山—都江堰、世界灌溉工程遗产都江堰水利工程、世界自然遗产四川大熊猫栖息地三项世界遗产所在地，先后荣获全国历史文化名城、国家园林城市、中国优秀旅游城市、首批国家全域旅游示范区、天府旅游名县、天府青城国家级康养旅游度假区等
    殊荣，辖区内拥有国家 AAAAA 级旅游景区 1 个、AAAA 级旅游景区 2 个、AA 级旅游景区1 个，以及熊猫乐园、熊猫谷、七里诗乡、玫瑰花溪谷等一批“旅游 +”融合发展景区，尤其是西南地区投资最大的融创文旅城自开业以来，已成为四川文旅产业发展的一颗璀璨明珠。</p>
    <h4>2019 年</h4>
    <p>全市共接待游客 2618.81.74 万人次，名列四川全省县级城市第一，旅游综合收入 308.14 亿元，居四川全省县级城市前三甲。</p>
    `,
    popup: {
      title: "都江堰市旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/16/dujiangyan.png" class="bimg" />
      <h4>支持高端品牌酒店建设。</h4>
      <p>对新引进《HOTELS》杂志排名前二十的世界知名酒店集团高端品牌，并签订品牌管理合同在 8年以上的，经认定，根据酒店排名情况给予项目投资方相应品牌奖励。对新进全球奢华精品酒店联盟（SLH）、中国小型豪华酒店联盟（SLHC）、中国精品酒店联盟（BHAC）酒店品牌，并签订品牌管理合同在 8 年以上的，经认定，根据酒店排名情况给予项目投资方相应品牌奖励。</p>
      <h4>支持酒店开展星级创建和品牌创建。</h4>
      <p>支持、指导辖区内酒店积极开展五星级旅游饭店、四星级旅游饭店、特色五级主题旅游饭店、特色四级主题旅游饭店以及绿色饭店、智慧饭店等创建，并在创建成功后，给予酒店运营方相应金额的一次性奖励，在达到一定运营规模后，再给予相应的扶持奖励；</p>
      <p>具体实施细则以当地正式颁发的政策为准。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "青城山高端文化旅游主题酒店",
        contact: "高琮人",
        phone: "13980410199",
        img_count: 3,
        desc: `
        <h4 class="title">青城山高端文化旅游主题酒店</h4>
        <h4>建设地点</h4>
        <p>青城山镇</p>
        <h4>建设工期</h4>
        <p>36 个月</p>
        <h4>投资总额</h4>
        <p>4 亿元人民币</p>
        <h4>建设内容</h4>
        <p>项目占地约 60 亩，引进国际高端 度假酒店品牌。</p>
        <h4>建设条件</h4>
        <p>宗地为商业地块，参考容积率为 0.5，限高 10 米，建议 100% 自持。</p>
        <h4>合作方式</h4>
        <p>招商引资</p>
        <h4>联系方式</h4>
        <p>高琮人（13980410199）</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "青城山高端康养主题酒店",
        contact: "高琮人",
        phone: "13980410199",
        img_count: 3,
        desc: `
        <h4 class="title">青城山高端康养主题酒店</h4>
        <h4>建设地点</h4>
        <p>青城山镇</p>
        <h4>建设工期</h4>
        <p>36 个月</p>
        <h4>投资总额</h4>
        <p>13 亿元人民币</p>
        <h4>建设内容</h4>
        <p>项目占地约 180 亩，引进国际高端酒店品牌。</p>
        <h4>建设条件</h4>
        <p>宗地为商业地块，参考容积率为 0.8， 限高 13 米，建议 100% 自持。</p>
        <h4>合作方式</h4>
        <p>招商引资</p>
        <h4>联系方式</h4>
        <p>高琮人（13980410199）</p>
        `,
      },
    ],
  },
  {
    img_count: 3, //轮播图的数量
    areaId: "pengzhou", //区域的id
    desc: `
    <p>彭州位于四川省成德绵经济圈和成都半小时经济圈内，是成都北向交通门户枢纽，成都西北部的生态屏障。拥有全国大中城市罕见的高地河谷景观资源，海拔从最高 4812 米到最低 489 米，森林覆盖率 49.5%，年平均气温 15.7℃，拥有多样性地形地貌和丰富特色资源。2019 年，接待游客 1915.3 万人次，同比增长11%；实现旅游总收入 75.68 亿元，同比
    增长 19.3%；接待过夜游客数 341 万人次，同比增长 12.17%，实现旅游业增加值为20.01 亿元，占全市 GDP 的比重为 4.86%，占第三产业的比重为 14.42%。</p>
    <p>作为彭州市文体旅产业发展的主阵地：龙门山湔江河谷生态旅游区是成都市 66 个产业功能区之一，规划面积 557.5 平方公里。旅游区处于“三九大”交汇区，涵盖彭州北部山区 6 个镇，生态环境优美，文旅资源富集，乡村林盘秀美。有 5 个国家级品牌资源，3 个国家 4A 级旅游景区，2 个省级旅游度假区。3000 年的发展历史，积淀了独具特色的古蜀文化、牡丹文化、文翁治水文化、陶瓷文化。便捷的多维交通网络“五高，六快，七轨”，推动彭州文旅产业迅速发展。</p>
    <p>旅游区高起点、高标准编制规划，引领旅游产业快速发展。确定了“湔江七星谷”的主题，依托湔江河谷沿线六个特色小镇，构建“一谷两麓、三级体验”的空间体系，按照“一区多园、七星耀江”总体布局和特色小镇错位协同产业发展的思路，拟建成以生态为本、文化为魂、产业为用、人居为乐的国际山地旅游休闲度假目的地。</p>
    <p>旅游区规划建设 10 个民宿聚落，1 个龙头产业园，即龙门山·柒村民宿产业园。产业园涉及桂花镇、通济镇的柒个村，以建设全国民宿产业园发展示范区为目标，整合社区治理、林盘打造，绿道建设等资源，规划建设 4 个民宿聚落组团，2 个主题公园，6 大生态公园，4 大度假组团。以民宿聚落为吸引，以公园配套组团为氛围，以共享度假小院为保障，构建从生态富集地到消费目的地的发展路径，形成“东有莫干山，西有龙门山”民宿发展格局。</p>
    `,
    popup: {
      title: "彭州市旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/17/pengzhou.png" class="bimg" />
      <p>对按照五星级酒店标准建设且与美国《HOTELS》杂志 ( 国际酒店与餐厅协会会刊 ) 发布的上年度“全球酒店集团 325 强”中排位前 20 名饭店集团签订 5 年及以上五星级标准高端品牌冠名合同并正式冠名的新引进酒店投资项目，在项目建成并投入运营，经评定达标后，给予不超过 1500 万元的品牌引入奖励。</p>
      <h4>对新评上的五星级、四星级、三星级乡村酒店，分别给予 50万元、10 万元、5 万元一次性奖励；</h4>
      <p>对在国内外城市交通枢纽、高速路服务区、旅游景点、大型酒店等重要场所新开设旅游商品专营店并符合标准要求的企业，按开店费用 30% 标准给予一次性补助，最高不超过 50 万元。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "龙源泽梦（民宿聚落）",
        contact: "王文睿,王路",
        phone: "18683934979,18349283919",
        img_count: 3,
        desc: `
        <h4>龙源泽梦（民宿聚落）</h4>
        <h4>建设地点</h4>
        <p>彭州市龙门山镇龙源村 12 组（原杨坪村 12 组）</p>
        <h4>建设工期</h4>
        <p>12 个月</p>
        <h4>投资总额</h4>
        <p>2600 万元</p>
        <h4>建设内容</h4>
        <p>包含 8 处宅基地，可旧房改造，打造龙源村民宿聚落，每处接待游客 5 到 8 组。</p>
        <h4>建设条件</h4>
        <p>宅基地总面积 3131.4 平方米，水电全通，部分通天然气。</p>
        <h4>合作方式</h4>
        <p>宅基地腾退。</p>
        <h4>联系方式</h4>
        <p>王文睿：18683934979；王路：18349283919</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "同心小区民宿聚落点打造",
        contact: "王文睿,王路",
        phone: "18683934979,18349283919",
        img_count: 3,
        desc: `
        <h4 class="title">同心小区民宿聚落点打造</h4>
        <h4>建设地点</h4>
        <p>彭州市通济镇天台山村同心小区</p>
        <h4>建设工期</h4>
        <p>24 个月</p>
        <h4>投资总额</h4>
        <p>2.4 亿元</p>
        <h4>建设内容</h4>
        <p>打造大型民宿聚落，包括娱乐设施及餐饮配套。</p>
        <h4>建设条件</h4>
        <p>地面积 80 亩；同心小区有农户 27户，宅基地合计 15 余亩，水、电已通，天然气未接入，毗邻有明昊玫瑰谷 50亩、有条件建设区 15 亩。</p>
        <h4>合作方式</h4>
        <p>联合经营</p>
        <h4>联系方式</h4>
        <p>王文睿：18683934979；王路：18349283919</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "毛家湾民宿聚落",
        contact: "王文睿,王路",
        phone: "18683934979,18349283919",
        img_count: 3,
        desc: `
        <h4 class="title">毛家湾民宿聚落</h4>
        <h4>建设地点</h4>
        <p>彭州市通济镇君山村</p>
        <h4>建设工期</h4>
        <p>18 个月</p>
        <h4>投资总额</h4>
        <p>10000 万元</p>
        <h4>建设内容</h4>
        <p>打造大型民宿聚落，隶属于龙门山·柒村民宿产业园区，规划完善，配套设施齐全。</p>
        <h4>建设条件</h4>
        <p>总面积 12333.3 平方米（18.5 亩），部分通水、电、天然气；毗邻龙门山·柒村民宿产业园区，基础设施及公共服务配套设施完善，游客流量相对集中。</p>
        <h4>合作方式</h4>
        <p>宅基地腾退</p>
        <h4>联系方式</h4>
        <p>王文睿：18683934979；王路：18349283919</p>
        `,
      },
    ],
  },
  {
    img_count: 2, //轮播图的数量
    areaId: "chongzhou", //区域的id
    desc: `
    <p>崇州古称蜀州，建制历史长达 4300 年，地处成都平原西部、天府之国腹心，自古为繁荣富庶之地，素有“蜀中之蜀”、“蜀门重镇”美誉。全市幅员面积 1090 平方公里，呈“四山一水五分田”格局，常住人口 78 万，是四川省首批命名的历史文化名城，是国家智慧城市试点城市、国家全域旅游示范区创建单位。</p>
    <p>在这片古老的土地上，滋养了陆游、杜甫、王勃等文人墨客的璀璨诗篇，传承着古风、古韵、古貌的厚重文化。1000 多年前，唐代诗人王勃在《送杜少府之任蜀州》一诗中留下了千古名句“海内存知己，天涯若比邻”；800 多年前，宋代著名爱国诗人陆游在蜀州两任通判期间，以“江湖四十余年梦，岂信人间有蜀州”的绝唱，为崇州留下了神奇的魅力和无尽的向往。</p>
    <p>作为国家级生态市，崇州拥有雪山、湿地、草甸等多种地貌，孕育出原始森林、温泉、大熊猫、古镇等多样风情，是成都平原的天然氧吧、第二水源地，年平均气温 15.9 摄氏度，森林覆盖率42.1%，素有“成都后花园”之称。</p>
    `,
    popup: {
      title: "崇州市旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/18/chongzhou.png" class="bimg" />
      <p>重点发展的服务业项目，崇州市康养旅游服务业聚集区项目固定资产投资不低于 1 亿元</p>
      <h4>生产性服务业</h4>
      <p>(1) 总部 ( 含采购中心、财务管理中心、结算中心 ) ; <br/>
        (2) 研发设计与技术服务 : 工程技术、农业科学、医养保健研发设计，科技成果转化及围绕科技成果转化、创新创业的各类服务 ; <br/>
        (3) 冷链物流 ; <br/>
        (4) 信息服务 : 大数据 ( 数据汇集、处理分析、应用服务 )、数字内容、物联网应用开发、电子商务 ( 跨境电商、农村电商 ) 及围绕二产业展开的信息技术服务 ; <br/>
        (5) 通用航空 : 通用航空运营、维修及与围绕通用航空的农林、测绘、科学研究等服务 ; <br/>
        (6) 私募风险投资基金 (VC)、私募股权投资基金 (PE) 及基金管理公司。<br/></p>
      <h4>生活性服务业</h4>
      <p>(1 ) 健康服务 : 医疗卫生、医养结合、养生养老、保健康疗项目 ;<br/> 
         (2) 旅游业 : 康养旅游、森林公园、体育旅游、观光度假、研修旅游、山地生态旅游、乡村休闲旅游、航空观光旅游，特色小镇打造 ;<br/>
         (3) 文化创意 : 音乐、文博、动漫、影视、手工艺品制作等相关文创类项目 ; <br/>
         (4) 教育培训 : 基础教育、培训服务 ;<br/>
         (5) 体育服务 : 国家级及以上体育赛事、休闲运动、航空运动等服务。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "成都街子洲际酒店项目",
        contact: "运营总经理邓嘉骏",
        phone: "18008006874",
        img_count: 3,
        desc: `
        <h4 class="title">成都街子洲际酒店项目</h4>
        <h4>建设地点</h4>
        <p>崇州市街子镇</p>
        <h4>建设工期</h4>
        <p>3—5 年</p>
        <h4>投资总额</h4>
        <p>约 5 亿元</p>
        <h4>建设内容</h4>
        <p>项目总规模 38 亩，建设国际豪华五星精品酒店，拟引进洲际·英迪格酒店酒店。项目分两期工程实施，其中一期总建筑面积约 20000 ㎡，建 162 间客房，二期酒店规划建筑 12000 ㎡，建客房 260 间。</p>
        <h4>建设条件</h4>
        <p>一是具有优良的区位优势。依托国家 AAAA 级旅游景区“五大天府古镇”、“兰花之乡”、“青城后花园”之称的崇州街子古镇。是通往世界著名风景名胜区必经之路，西距成都 40 公里，北距凤栖山 10 公里，东北与都江堰接壤。毗邻青城后山和九龙沟，地理交通位置极其便利。二是具备独特的资源优势。项目所在地街子古镇，在崇州城西北25 公里的凤栖山下，与青城后山连接。有以晋代古刹光严禅院为中心的 32 座寺庙等古迹。 境内有晋代古刹——光严禅院、凤栖山旅游风景区、千亩原始森林、千年银杏、千年古楠、清代古塔、清末民初古建一条街、宋代民族英雄王小波起义遗址、唐代一瓢诗人——唐求故居，有古龙潭、五柜沱、云雾洞等，全镇各种文物古迹二十余处。岷江的支流味江流经地势平缓的街子镇口，形成一泓碧潭——龙潭。古镇水系发达，地下水丰富，石板路两侧及屋前院后，常年清水不断，因而有“川西水乡”之名、“青城后花园”之称。</p>
        <h4>合作方式</h4>
        <p>合资或独资</p>
        <h4>联系方式</h4>
        <p>运营总经理邓嘉骏；18008006874</p>
        `,
      },
    ],
  },
  {
    img_count: 3, //轮播图的数量
    areaId: "qionglai", //区域的id
    desc: `
    <p>邛崃地处成都平原西南部，位于成都市“半小时经济圈”，距成都市区约 65 公里、天府新区成都直管区约 33 公里，距成都双流机场约 50 公里、成昆铁路普兴火车站 40 公里，是川西地区重要的交通枢纽和西藏连接四川的重要物资集散地。幅员 1377 平方公里，管辖 14 个街镇，人口 66 万。现有成名高速公路、成雅高速公路、成温邛快速路、成新蒲快速路、新邛路等交通要道与外界相连，随着“三轨四高五快”对外交通体系逐步建成，邛崃交通、物流将更加便捷。</p>
    <p>邛崃古称临邛，筑城置县已有 2300 多年历史，是巴蜀四大古城之一、古南方丝绸之路西出成都第一站和茶马古道第一镇，素有“临邛自古称繁庶，天府南来第一州”的美誉。邛崃是西汉著名才女卓文君的故乡，“文君当垆、相如涤器”演绎了“凤求凰”的千古绝唱，被誉为“世界十大经典爱情传奇”。境内文物古迹众多，全市共有邛窑遗址、南宋石塔、邛崃石窟等各级文物 178 处（点），其中“国家级文物保护单位”3 处、“省级文物保护单位”7 处。自西汉以来，邛崃留下了司马相如、陆游等诗词大家的诗词妙句 400 余首，处处尽显“两千年秦汉文化，三百里绿色风情”。</p>
    <p>邛崃是一座山清水秀的城市，境内山川秀丽、气候温和、资源丰富，䢺江河、斜江河、南河等 5 条主要河流穿境而过，全市森林覆盖率 48%。天台山山青青、水碧碧，高山流水韵依依，令人流连忘返！临邛古城被西河、南河两条“玉带”环抱，是人们向往的“以山为屏，以水为镜”的人居福地！平乐古镇的古驿道旁、古榕树下，至今还演绎着茶马古道的繁华！ </p>
    <p>近年来，邛崃市加快科学发展，先后获得了国家生态市、中国优秀旅游城市、中国最大白酒原酒基地、中国白酒原酒之乡、中国食品工业百强县（市）、全国食品工业十大发展特色县、全国农业化工作先进单位、国家商品油料生产基地、全国粮食生产先进县、全国双拥模范城、四川省县域经济发展先进县和四川省林业产业强县、四川省现代畜牧业重点县、四川省食品工业十五强县、四川省乡村旅游强县等众多殊荣。 </p>
    <p>当前，邛崃正认真贯彻中央“五位一体”总体布局和“四个全面”战略布局，省委“一干多支、五区协同”“四向拓展、全域开放”战略和成都市委建设全面体现新发展理念的城市的决策部署，紧紧围绕邛崃建设成都西部区域中心城市的目标，奋力推进“六个走在前列”，加快高标准全面建成小康社会进程。</p>
    <p>邛崃是一个开放开明的城市。先后迎来了国内外众多知名企业前来观光考察、投资发展，成甘工业园区、天邛产业园区、临邛工业园区良好的投资环境，吸引了达能集团、阿克苏·诺贝尔以及立邦油漆、伊利乳业、神威药业、长兴化工、金六福酒业等世界 500 强和国内外知名企业落户</p>
    `,
    popup: {
      title: "邛崃市旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/19/qionglai.png" class="bimg" />
      <p>一事一议</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "白鹤山康养酒店项目",
        contact: "杨进",
        phone: "13438190115",
        img_count: 2,
        desc: `
        <h4 class="title">白鹤山康养酒店项目</h4>
        <h4>建设地点</h4>
        <p>临邛街道鹤鸣社区</p>
        <h4>建设工期</h4>
        <p>3 年</p>
        <h4>投资总额</h4>
        <p>5 亿元</p>
        <h4>建设内容</h4>
        <p>项目依托白鹤山景区和临邛古城文化，建设集花园酒店、老年人养护中心、颐养公园、西南地区养老护理人员培训中心为一体的康养度假酒店。</p>
        <h4>建设条件</h4>
        <p>项目东依临邛古镇，西靠鹤林禅院，南临九里泮，与“自然康养”紧密结合，可利用现有幽居寺禅寺资源，打造高标准现代服务业康养区。白鹤山景区位于邛崃市西城区近郊 6 公里处，鹤林禅院座落于山中，占地近百亩，是省重点宗教活动点，邛崃市级文物保护单位和对外开放的旅游点。项目交通便利，西城区近郊 6 公里处，连接邛名高速路口，黄坝大桥往白鹤山方向驶入即可到达。</p>
        <h4>合作方式</h4>
        <p>独资、合作等</p>
        <h4>联系方式</h4>
        <p>杨进 联系电话：13438190115</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "平乐度假酒店项目",
        contact: "周志武",
        phone: "13699033837",
        img_count: 3,
        desc: `
        <h4 class="title">平乐度假酒店项目</h4>
        <h4>建设条件</h4>
        <p>平乐古镇距离成都 93 公里，是成都 100 公里范围内集天府古建、川西竹海、南方丝绸之路、音乐爱情为主题的古镇。目前有轨道、高速、快速通道等多维度的立体交通网络直达平乐从成都出发只需一个小时的车程就可以到达平乐古镇。平乐距离邛崃市区只有 18 公里，邛崃市自古称为“天府南来第一州”，是川滇、川藏公路要塞、西汉著名才女卓文君的故里、是四川最早的四大古城之一。平乐古镇山清水秀，气候宜人，白沫江穿镇而过。历史文物古迹众多，有川西竹海、芦沟竹海景区、金华佛山，在川西竹海景区内竹林茂盛，山川俊朗，怪石突兀，成片竹海面积达十万余亩。空气中每立方米负氧离子含量达 200 余万个，氧气含量最高约为 19%，是成都市区的数百倍，为成都地区之最，有此被人们誉为“天然氧吧”、“超洁净空气”、“绿色幽谷”。平乐古镇历史文化悠久，文化源远流长。平乐自古便为“茶马古道第一镇、南丝绸之路的第一驿站，素以“秦汉文化 • 川西水乡”风情著称。漫步在古镇上除了体味千年的建筑历史文化的风采同时也可以品味古镇劳动人民两千多年来的民俗文化朴实的老百姓创造了山歌会、河灯会、牛儿灯、放生会、六月六观音会等。漫步古镇，游客将亲身体验到古镇的种种风情与它那悠长的古寺，古堰，古坊，古树，古风，古歌等平乐“九古文化”</p>
        <h4>建设地点</h4>
        <p>邛崃市平乐镇</p>
        <h4>建设工期</h4>
        <p>5 年</p>
        <h4>投资总额</h4>
        <p>15 亿元</p>
        <h4>建设内容</h4>
        <p>项目选址位于平乐白沫江旁，依托邛崃丝路文化、文君文化等，打造集住宿体验、特色餐饮、休闲度假为一体的高端度假酒店。</p>
        <h4>合作方式</h4>
        <p>独资、合作等</p>
        <h4>联系方式</h4>
        <p>联系人：周志武 联系电话：13699033837</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "火井温泉酒店项目",
        contact: "李雪梅",
        phone: "15802886246",
        img_count: 3,
        desc: `
        <h4 class="title">火井温泉酒店项目</h4>
        <h4>建设地点</h4>
        <p>邛崃市火井镇</p>
        <h4>建设工期</h4>
        <p>5 年</p>
        <h4>投资总额</h4>
        <p> 10 亿元</p>
        <h4>建设内容</h4>
        <p>项目依托火井独特的人文、地理及温泉资源，规划建设森林温泉精品民宿、森林康养、古镇文化民宿体验为一体的森林温泉酒店项目。</p>
        <h4>建设条件</h4>
        <p>火井镇地处邛崃市西路，距邛崃市区 31 公里，镇域平均海拔 894 米，年平均气温在 14℃左右。火井镇是世界上最早发现和使用天然气的地方，发现天然气时就有伴生盐卤水（即温泉）。火井镇是极少出现“水气共存”的地方；国家地勘队在火井盐井溪作浅表层钻探时打探出天然气和盐卤水，其盐卤水水温为 40 摄氏度左右，含盐卤量 7％，是理想的温泉度假地理资源。</p>
        <p>连接雅安的邛芦路贯穿全境，距天台山风景名胜区约 10 公里、平乐古镇约 10 公里，距成都第三绕城高速水口约 15 公里，距成名高速约 15公里，位于成都 1.5 小时经济圈范围。目前，天邛高速（成都天府新区—邛崃）正在规划中，在火井镇有一出入口。</p>
        <h4>合作方式</h4>
        <p>独资、合作等</p>
        <h4>联系方式</h4>
        <p>联系人 - 李雪梅 | 联系电话 -15802886246</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "临济镇铜沟特色民宿项目",
        contact: "黄朝银",
        phone: "15108278108",
        img_count: 2,
        desc: `
        <h4 class="title">临济镇铜沟特色民宿项目</h4>
        <h4>建设条件</h4>
        <p> 临济镇位于平乐古镇 . 天台山国家 5A 级景区沿线，成都一小时交通圈，距成都 85 公里，距邛崃 25 公里，距天台山 16 公里，距平乐古镇 6 公里，距邛名高速 4 公里，交通十分便捷。铜沟有良好的生态环境和人文历史。境内群山环抱，山清水秀，竹海成荫。竹海内奇峰怪石、天然溶洞、茂林修竹交相辉映，环境优美，夏季最高气温在 22℃左右。景区以十里梨花长廊、秀丽的石林、清代古民居建筑、造纸作坊和溶洞等典型的景观为代表，而闻名于川西，是探幽、攀险、访古、休闲旅游之最佳去处。铜沟历史悠久，有着历史沉淀与文化气息的老屋，有清代何家大院的遗迹，有红四方面军与国民党作战的战壕遗址，幽静的环境，淳朴的民风，整洁的院落，成片成规模。回归自然，返璞归真，这里是一尘不染的静怡村落、是原滋原味的生态美味村落、是民风淳朴的原始村落。来到铜沟，这里的清爽气候、干净整洁环境、淳厚朴实的民风，让人荡涤心灵，让人心旷神怡！一处隐藏在青葱小山后面的美丽村庄，清新院落，翠竹森森，兰花幽静，无一不凸显着现代人心中关于“归田园居”的理想生活。</p>
        <h4>建设地点</h4>
        <p>临济镇张店村 8 组（铜沟）</p>
        <h4>建设工期</h4>
        <p>2 年</p>
        <h4>投资总额</h4>
        <p>总投资 0.5 亿元</p>
        <h4>建设内容</h4>
        <p>项目通过整合铜沟的生态、文化、旅游资源，对铜沟内已有的 19 户名宿客栈进行统一的打造整理；对区域内清代的何家大院建筑遗址进行挖掘展示，打造成为一个清代遗址文化展览馆，展示铜沟历史文化，建筑文化，民风民俗。</p>
        <h4>合作方式</h4>
        <p>独资、合作等</p>
        <h4>联系方式</h4>
        <p>黄朝银 (15108278108)</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "芦沟竹海民宿项目",
        contact: "周志武",
        phone: "136-9903-3837",
        img_count: 3,
        desc: `
        <h4 class="title">芦沟竹海民宿项目</h4>
        <h4>建设条件</h4>
        <p>平乐古镇距离成都 93 公里，是成都 100 公里范围内集天府古建、川西竹海、南方丝绸之路、音乐爱情为主题的古镇。目前有轨道、高速、快速通道等多维度的立体交通网络直达平乐，从成都出发只需一个小时的车程就可以到达平乐古镇。项目所在地川西竹海景区内竹林茂盛，山川俊朗，怪石突兀，成片竹海面积达十万余亩。空气中每立方米负氧离子含量达 200 余万个，氧气含量最高约为 19%，是成都市区的数百倍，为成都地区之最，由此被人们誉为“天然氧吧”、“超洁净空气”、“绿色幽谷”。</p>
        <h4>建设地点</h4>
        <p>邛崃市平乐镇芦沟</p>
        <h4>建设工期</h4>
        <p>2 年</p>
        <h4>投资总额</h4>
        <p>1 亿元</p>
        <h4>建设内容</h4>
        <p>项目依托平乐镇生态自然资源环境，整合芦沟竹海现有民房、林盘资源，通过挖掘竹元素，探索创新竹林旅游新模式，以优秀生态与高端体验，提升区域的旅游品质，打造竹奢民宿、休闲度假、竹创体验、康体养生为一体的竹海民宿群落。</p>
        <h4>合作方式</h4>
        <p>独资、合作等</p>
        <h4>联系方式</h4>
        <p>周志武 (136-9903-3837)</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "平乐关帝村精品酒店项目",
        contact: "周志武",
        phone: "136-9903-3837",
        img_count: 3,
        desc: `
        <h4 class="title">平乐关帝村精品酒店项目</h4>
        <h4>建设条件</h4>
        <p>平乐古镇距离成都 93 公里，是成都 100公里范围内集天府古建、川西竹海、南方丝绸之路、音乐爱情为主题的古镇。目前有轨道、高速、快速通道等多维度的立体交通网络直达平乐，从成都出发只需一个小时的车程就可以到达平乐古镇。项目选址古泉眼位于平乐镇关帝村东部，关帝村毗邻芦沟竹海，距离平乐 3公里，距国道 318 线 12 公里，离邛崃市区 21 公里，交通便利。古泉眼位于山脉峡谷之中，两侧青峰叠嶂，风景秀丽。</p>
        <h4>建设地点</h4>
        <p>邛崃市平乐镇关帝村</p>
        <h4>建设工期</h4>
        <p>5 年</p>
        <h4>投资总额</h4>
        <p>3 亿元</p>
        <h4>建设内容</h4>
        <p>项目占地面积约 60 亩，位于平乐镇关帝村宝泉湖畔，以古泉眼为基础、以宝泉湖景及白沫江景为载体，建设融商务会议、咖啡茶饮、餐饮娱乐、住宿等为一体的精品主题酒店项目。</p>
        <h4>合作方式</h4>
        <p>独资、合作等</p>
        <h4>联系方式</h4>
        <p>周志武 (136-9903-3837)</p>
        `,
      },
    ],
  },
  {
    img_count: 2, //轮播图的数量
    areaId: "xinjin", //区域的id
    desc: `
    <h4>南方丝绸古道第一站</h4>
    <h4>成都南大门</h4>
    <p>新津位于成都市南部，形似“超级绿叶”，是成都平原古蜀文明发源地之一，有 1460 年建城史，古有“南方丝绸古道第一站”美誉，今有“成都南大门”之称，是川西多条旅游精品线路的黄金交汇点。</p>
    <p>新津幅员面积 330 平方公里，区域内文化旅游资源丰富，是国家生态县、国家园林县城、四川省旅游强县。境内有全国重点文物保护单位宝墩遗址、观音寺，白鹤滩国家湿地公园，国家 4A 级旅游景区花舞人间、斑竹林，省级旅游度假区梨花溪。</p>
    <p>2019 年接待国内游客 1738 万人次，同比增长 19.86%；接待入境游客 2.9 万人次，同比增长 15.2%，实现旅游综合收入 52.3 亿元，同比增长 31.83%。2019 年旅游及相关产业税收比重达到 23.2%，旅游从业人员占全区从业人员总数比重为 15.2%</p>
    `,
    popup: {
      title: "新津县旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/20/xinjin.png" class="bimg" />
      <p>对新落户、固定资产投资 5 亿元（不含土地价格）以上的重大文旅项目，建成投运后按实际投资总额的 0.5%，给予企业最高不超过 500 万元的一次性补贴。</p>
      <p>对年度地方经济贡献 10 万元以上的新落户的影视、动漫、游戏、VR/AR、音乐、演艺、体育、文创、旅行社等山水运动、文化创意、旅游服务产业，从注册之日起 3 个年度内，以对我县年度地方经济贡献为参照数，第一年按 100% 给予企业产业支持，第二年、第三年分别按 80%、60% 给予产业扶持。</p>
      <p>对新评定的五星级、四星级酒店，分别给予获评业主 200 万元、100 万元的一次性奖励；对新评定的五星级、四星级、三星级民宿分别给予获评业主 50万元、30 万元、10 万元的一次性奖励。</p>
      <p>以上扶持政策来自于中共新津县委办公室 新津县人民政府办公室关于印发《新津县支持文体旅产业发展政策》的通知（新委办〔2020〕5 号）</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "竹林公园地块",
        contact: "文绍春",
        phone: "135-5007-3336",
        img_count: 2,
        desc: `
        <h4 class="title">竹林公园地块</h4>
        <h4>建设地点</h4>
        <p>新津区永商镇</p>
        <h4>建设工期</h4>
        <p>3—5 年</p>
        <h4>投资总额</h4>
        <p>13 亿元</p>
        <h4>建设内容</h4>
        <p>拟招引集酒店、餐饮、会议、健身、休闲为主的文旅项目。</p>
        <h4>建设条件</h4>
        <p>位于新津梨花溪文化旅游区的文化创意组团，紧邻南河、老君山、花舞人间， 是老码头艺术街区的重要组成部分，与地铁 10 号线宝墩站仅 1 公里，周边配套齐全。</p>
        <h4>合作方式</h4>
        <p>合资或独资</p>
        <h4>联系方式</h4>
        <p>文绍春 (135-5007-3336）</p>
        `,
      },
    ],
  },
  {
    img_count: 2, //轮播图的数量
    areaId: "dayi", //区域的id
    desc: `
    <h4>雪山下的公园城市 - 大邑</h4>
    <p>大邑县幅员面积 1327 平方公里，森林覆盖率近 60%。从海拔475m 的平原到海拔 5364m 的雪山，被联合国人居署授予最适宜人居的城市。一千多年前的杜甫、陆游感怀于这片山水的神奇，成为“窗含西岭千秋雪”“长看天西万叠青”的千古代言。获得了国家生态县、四川省旅游强县、四川省乡村旅游示范县、四川省旅游标准化示范县、四川省天府旅游名县候选县等荣誉称号</p>
    <p>全县拥有 6 个国家 4A 级旅游景区，分别是世界自然遗产中国四川大熊猫核心栖息地 - 西岭雪山，联合国人居（中国）范例贡献奖优秀奖 - 花水湾温泉度假小镇，亚洲民间博物馆杰出奖 - 建川博物馆聚落，中国历史文化名镇 - 新场古镇，全国重点文物保护单位、国家爱国主义教育基地 - 刘氏庄园博物馆，潮成都人气打卡地 - 天府花溪谷。共有中高端型涉旅酒店 50 家，床位数 8000 余张，其中三星级及以上旅游饭店 2 家。</p>
    `,
    popup: {
      title: "大邑县旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/21/dayi.png" class="bimg" />
      <p>1.对新评为白金五星、五星、四星、三星级旅游饭店，分别给予一次性奖励 400 万元、200 万元、100 万元、50 万元。对上述旅游品牌，通过三年一次的评定性复核后，每次给予 10 万元、8 万元、5万元、2 万元的一次性奖励。</p>
      <p>2. 对新评为五星级、四星级、三星级旅游民宿分别给予一次性奖励 40 万元、20 万元、10 万元；新评为金芙蓉级、银芙蓉级主题客栈，分别给予一次性奖励 40 万元、20 万元；新评为金鼎级、银鼎级文化主题旅游饭店，分别给予一次性奖励 40 万元、20 万元；新评为绿色旅游饭店，给予一次性奖励 30万元。</p>
      <h4>支持引进高端旅游品牌 :</h4>
      <p>1. 对新引进的按照五星级酒店及以上标准建设的酒店投资项目，且与国际知名酒店集团签订 5 年及以上高端酒店品牌经营管理合同的，一次性给予酒店投资企业 300 万元—500 万元的品牌引入费用奖励。</p>
      <p>2. 鼓励投资建设度假酒店、精品酒店、主题酒店。</p>
      <p>3. 按照星级酒店标准建设，加入全球奢华酒店联盟（SLH）、中国小型豪华酒店联盟（SLHC）、中国精品酒店联盟（BHAC）的酒店，按每个房间 2万元的标准给予一次性奖励，最高不超过 500 万元。</p>
      <p>4. 鼓励引进并投资建设国际高端温泉水疗综合体（如 AYANA Resort and Spa 阿娅娜等）、温泉（恒温）浴场（如迪泉优等）、SPA 及水疗品牌（如 Six Sensess Spa 六感 SPA 等）等，经审核认定属全球排名前五十，一次性给予引进企业 100 万 -300 万元奖励。</p>
      <p>5. 对新评为五星级、四星级、三星级乡村酒店，分别给予一次性奖励 20 万元、10 万元、5 万元；对新评为五星级、四星级、三星级农家乐，分别给予一次性奖励 15 万元、8 万元、3 万元。</p>
      <p>6. 对新评定为全市智慧旅游景区、智慧旅游饭店的，依据有关评定办法，按 85（含）—90 分以下、90（含）—95 分以下、95（含）—100 分三个档次，在上级奖励的基础上，对达标的旅游景区分别给予一次性奖励 10 万元、20 万元、40 万元；对达标的旅游饭店，分别给予一次性奖励 5 万元、10 万元、20 万元。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "庭院文创酒店",
        address: "邑县安仁文博产业功能区",
        yusuan: "10000 万元",
        img_count: 2,
        desc: `
        <h4 class="title">庭院文创酒店</h4>
        <h4>建设地点</h4>
        <p>邑县安仁文博产业功能区</p>
        <h4>建设工期</h4>
        <p>待定</p>
        <h4>投资总额</h4>
        <p>10000 万元</p>
        <h4>建设内容</h4>
        <p>项目占地 11 亩，现有建筑面积2300 ㎡，建筑层高 1-2 层，布局较为散落，且具有较大的院落空间，拥有一片小型地上停车区域。拟通过出租、共同投资营业分成模式，引入文创、民宿、酒店商家，打造高端精品度假酒店。</p>
        <h4>合作方式</h4>
        <p>待招商</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "金桂文创酒店",
        address: "邑县安仁文博产业功能区",
        yusuan: "10000 万元",
        img_count: 1,
        desc: `
        <h4 class="title">金桂文创酒店</h4>
        <h4>建设地点</h4>
        <p>邑县安仁文博产业功能区</p>
        <h4>建设工期</h4>
        <p>待定</p>
        <h4>投资总额</h4>
        <p>10000 万元</p>
        <h4>建设内容</h4>
        <p>用地面积 39.39 亩，建筑面积 7506.49 ㎡，土地性质为综合用地，该项目为院落式酒店，有三栋建筑物，紧邻刘氏庄园，目前处于未经营状态，已取得国有土地使用权证。邑县安仁文博产业功能区。</p>
        <h4>合作方式</h4>
        <p>待招商</p>
        `,
      },
    ],
  },
  {
    img_count: 2, //轮播图的数量
    areaId: "jintang", //区域的id
    desc: `
    <h4>中国人居环境范例奖</h4>
    <h4>国家生态文明建设示范县</h4>
    <h4>国家园林县城</h4>
    <h4>四川省乡村旅游强县</h4>
    <h4>全国旅游创新发展示范地</h4>
    <h4>首批国民休闲旅游胜地</h4>
    <h4>2019 中国体育旅游目的地</h4>
    <h4>国际铁联铁人三项世界杯赛黄金主办城市</h4>
    <h4>2019 特色旅游魅力城市</h4>
    <h4>2019 文旅融合发展优秀城市</h4>
    <p>金堂地处成都平原东北部，龙泉山脉穿境而过，千里沱江自此起源，大山大水孕育出大美的自然风光和深厚的历史人文，自古便是川西水陆交通枢纽和商贾云集之地，如今更是四川省经济增长最快和最具投资潜力的城市之一。我县在融合发展、基础配套、产业布局、市场营销、品牌创建等方面加大投入力度，初步形成了“春赏花、夏亲水、秋养生、冬美食，一年四季主题鲜明”的旅游发展格局。</p>
    <h4>国家 AAAA 级旅游景区 1 个</h4>
    <p>五凤溪景区</p>
    <h4>国家 AAA 级旅游景区 3 个</h4>
    <p>西南航空文化旅游景区、转龙鲜花山谷景区、玉皇养生谷景区</p>
    <h4>国家 AA 级旅游景区 2 个</h4>
    <p>脐橙之乡、竹篙花熳天下</p>
    <h4>国家级历史文化名镇 1 个</h4>
    <p>五凤古镇</p>
    <h4>国家级文保单位 1 处</h4>
    <p>淮口瑞光宝塔</p>
    <h4>省级旅游度假区 1 个</h4>
    <p>毗河湾旅游度假区</p>
    <h4>AAA 级林盘景区 2 个</h4>
    <p>甘御兰铁皮石斛林盘景区</p>
    <p>梨花酒乡林盘景区</p>
    <h4>市级旅游特色村 7 个</h4>
    <p>赵镇香龙山村、栖贤乡梨花沟村、三溪镇白庙村、淮口镇长江村、白果镇廻龙湾村、广兴镇宝塔村、官仓镇双新村</p>
    <h4>主题旅游目的地 6 个</h4>
    <p>甘御兰石斛养生旅游基地、花田广兴、西南航空文化旅游景区、玉皇养生谷、聚峰谷国际橄榄旅游区、创意灯笼文化旅游区</p>
    <h4>县内有五星级标准酒店 1 家</h4>
    <p>成都金堂恒大酒店</p>
    <h4>四星级酒店 1 家</h4>
    <p>华美达安可酒店</p>
    <h4>三星级酒店 1 家</h4>
    <p>金裕大酒店</p>
    <h4>主题客栈 2 家</h4>
    <p>德门仁里、半山美宿</p>
    <h4>绿色饭店 2 家</h4>
    <p>爪龙溪花园大酒店、华美达安可酒店</p>
    <h4>经济酒店和社会旅馆 200 余家</h4>
    <h4>农家乐 / 乡村酒店 137 家</h4>
    <p>其中星级农家乐 / 乡村酒店 2 家</p>
    <h4>旅行社（服务网点）40 余家</h4>
    <p>旅游从业人员 8100 余人</p>
    <p>未来，我们将聚焦成都“三城三都”建设，紧扣构建“淮州为核、三区联动”城市发展新格局，大力推动文化农业商贸体育旅游融合发展，筑牢以项目为引领的产业发展基石。</p>
    <p>一是加快港中旅温泉旅游度假区、五凤古镇二期、淮州新城文化中心等项目建设，争取项目早日呈现；密切跟踪欢乐夜间野生动物城等文化旅游项目，争取项目尽快签约。</p>
    <p>二是持续推进五凤古镇提升创建国家 5A 级旅游景区、玉皇养生谷提升创建国家 4A 级旅游景区等。</p>
    <p>三是积极培育一批体育旅游示范基地、研学教育基地、水上夜游等旅游业态，推进我县旅游业健康有序发展。</p>
    `,
    popup: {
      title: "金堂县旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/22/jintang.png" class="bimg" />
      <p>对符合我县政策招引酒店项目实行一事一议，且不低于成都同类相关旅游产业政策标准。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "龚家山甘御兰民宿",
        address: "淮口镇龚家山村二组",
        phone: "028-84982154",
        img_count: 3,
        desc: `
        <h4 class="title">龚家山甘御兰民宿</h4>
        <h4>建设地点</h4>
        <p>淮口镇龚家山村二组</p>
        <h4>建设工期</h4>
        <p>12 个月</p>
        <h4>投资总额</h4>
        <p>约 1500 万元</p>
        <h4>建设内容</h4>
        <p>拟在龚家村二组以石斛文化、博物馆、石斛养生等为载体，打造西南首个涵盖吃、住、行、游、购、娱、研于一体，以铁皮石斛为主题的特色旅游民宿点位。</p>
        <h4>建设条件</h4>
        <p>民宿主体建筑，共约 1500 平方，主要包含住宿、餐饮、品茗、会议、展览体验等功能；民宿周边景观打造、农业产业主题开发。</p>
        <h4>合作方式</h4>
        <p>独资、合资</p>
        <h4>联系方式</h4>
        <p>028-84982154</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "龙泉山主题民宿集聚区",
        address: "龙泉山城市森林公园金堂片区",
        phone: "028-84982154",
        img_count: 3,
        desc: `
        <h4 class="title">龙泉山主题民宿集聚区</h4>
        <p>龙泉山主题民宿集聚区含赵镇、淮口、白果、五凤等街道（镇），结合沱江绿道、龚家山、五凤古镇沿途的山形地貌、水利等自然资源，整合美丽宜居乡村、传统村落改造等项目资源，融入沱江、宋蒙、孝善、哲学及书法等文化元素，打造以自然生态、文艺创作功能为主题的休闲民宿群落。</p>
        <h4>建设地点</h4>
        <p>龙泉山城市森林公园金堂片区</p>
        <h4>建设工期</h4>
        <p>约5年</p>
        <h4>投资总额</h4>
        <p>10-20 亿元</p>
        <h4>建设条件</h4>
        <p>龙泉山城市森林公园金堂片区内文旅资源丰富，已创建国家 4A 级旅游景区五凤溪景区、国家3A 级旅游景区玉皇养生谷景区、云顶石城省级风景名胜区、毗河湾省级旅游度假区等一批文化旅游景区。目前我县围绕“淮州为核 三区联动”城市发展新格局，奋力建设成都东北部区域中心城市，加快龙泉山城市森林公园金堂片区旅游基础设施及相关配套建设，为区域内民宿建设提供良好条件。</p>
        <h4>合作方式</h4>
        <p>独资、合资</p>
        <h4>联系方式</h4>
        <p>028-84982154</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "淮州新城特色酒店集聚区",
        address: "淮州新城招商中心周边",
        phone: "028-84982154",
        img_count: 3,
        desc: `
        <h4 class="title">淮州新城特色酒店集聚区</h4>
        <p>依托淮州新城招商中心及周边现有资源，引进专业经营管理合作方，建设开发多家不同风格的商务连锁酒店。酒店项目建设占地面积约 58 亩，建筑面积约为 19 万平方米，目前周边还有 67 亩商业用地可用。</p>
        <h4>建设地点</h4>
        <p>淮州新城招商中心周边</p>
        <h4>建设工期</h4>
        <p>3 年</p>
        <h4>投资总额</h4>
        <p>5-10 亿元</p>
        <h4>建设条件</h4>
        <p> 为更好的为淮州新城招商提供展示空间、接待办公场所、并成为对外展示淮州新城形象的窗口，拟引进专业经营管理合作方建设开发多家不同风格的商务连锁酒店，打造沱江沿岸主题酒店集聚区。目前已建成占地约 42 亩，总建筑面积 4674 平方米并拥有会议室、展厅、餐厅以及休闲区，具备召开各种大中型会议的招商中心。招商中心主要含展厅、会议室、餐厅等配套设施。</p>
        <h4>合作方式</h4>
        <p>独资、合资</p>
        <h4>联系方式</h4>
        <p>028-84982154</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "云观假日度假酒店",
        address: "",
        yusuan: "约6亿元",
        img_count: 3,
        desc: `
        <h4 class="title">云观假日度假酒店</h4>
        <h4>所属区（市）县</h4>
        <p>金堂县</p>
        <h4>投资总额</h4>
        <p>约 6 亿元</p>
        <h4>项目签约双方</h4>
        <p>甲方金堂县人民政府、乙方待定</p>
        <h4>项目概况</h4>
        <p>项目用地面积约 600 亩，其中建设用 地约 100 亩，流转用地约 500 亩，建 设精品度假酒店、亲子度假休闲体验 区、康养观光农业体验区等。</p>
        `,
      },
    ],
  },
  {
    img_count: 3, //轮播图的数量
    areaId: "pujiang", //区域的id
    desc: `
    <h4>国家全域旅游示范区创建单位</h4>
    <h4>首批省级全域旅游示范区</h4>
    <p>“带二江之双流，抗峨眉之重阻”，左思一首《蜀都赋》，为双流赋予美名。双流位于成都市南面，是成都市的中心城区，是双流国际机场的所在地。全区实际管辖面积 466 平方公里、服务人口 150 万，2019年实现地区生产总值 962 亿元、增长 8.8%，可支配财力 207.88 亿元，在全国百强区排名中，位列第 32位。目前全区拥有 4A 级景区 2 个，高星级及精品酒店 30 余家，2019 年接待游客 1609.4 万人次、过夜游客 560 万人次。</p>
    <p>拥有“三山两河”“三湖一阁”的自然生态本底，森林覆盖率 66.89%，排名成都市第一，蒲江县始建于公元 554 年，是南宋著名理学家魏了翁和抗日名将李家钰的故乡，拥有蒲江石窟——飞仙阁、龙拖湾摩崖造像、茶马古道等全国重点文物保护单位、省市县级文保单位 50 处，拥有大型战国船棺墓葬群和宋代冶铁遗址、中国唯一的汉代牢盆，以及“成都矛”——将成都城市称谓的历史前推了 200 年。依托良好的生态、现代农业产业优势，蒲江县引进了云顶水乡、蓝莓谷、花开麟凤、天府农创园等重大产业化项目，打造了石象湖、成佳茶乡 2 个国家 4A级景区，樱桃山 3A 级景区，大溪谷省级旅游度假区、朝阳湖省级风景名胜区；猕猴桃国际公园、天府农创园、明月村文创园区、蒲砚基地等旅游新业态如雨后春笋遍布全域。常年举办石象湖郁金香节、百合花节，采茶节，樱桃节、蓝莓节、全国重阳登高健身大会等主题节赛活动。</p>
    `,
    popup: {
      title: "蒲江县旅游住宿业<br/>招商引资政策", //弹窗标题
      content: `
      <img src="./images/area/23/pujiang.png" class="bimg" />
      <h4>引进文创旅游项目扶持资金</h4>
      <p>新引进投资 10 亿元及以上重大文旅产业项目，在约定建设周期（不超过两年）内完成建设，自营业之日起前三年每年地方财政贡献额在 100 万元以上，分别按照项目公司当年地方财政贡献额的 80%、70%、60% 给予奖励。</p>
      <p>对面向社会公开征集通过评审立项并完成建设的文创旅游项目，以及融合发展新业态项目（比如旅游 + 教育、旅游 + 工业、旅游 + 科技等），经验收合格后，按照实际投资额给予不超过 30% 的一次性补助。</p>
      <p>艺术家、创客、文创企业或者旅游专合组织利用农村宅基地、闲置资产、老旧建筑（院落）等，保护利用林盘打造特色街区、发展文创旅游项目的，通过评审立项，按实际改造固定资产投资额的 30% 给予最高不超过 50 万元一次性补助。</p>
      <p>对新引进的包含住宿、停车场等功能完善的汽车旅馆、帐篷营地、房车营地、自驾车营地等项目，在约定建设周期内（不超过两年）完成建设，按照实际固定资产投资额的 10% 给予最高不超过 50 万元的一次性补助。</p>
      <h4>研发文创旅游商品扶持资金</h4>
      <p>非物质文化遗产项目进行产业化开发，推出文创旅游商品，并进行了版权登记的，通过竞争性立项，按照项目开发资金的 50% 给予开发单位最高不超过 20 万元的一次性补助。</p>
      <p>加大文创旅游商品研发与品牌推介力度，加强知识产权运用和保护，对获得国家级、省、市级重大奖项的文创旅游商品等分别给予 10 万元、6万元、3 万元的一次性奖励；对成功获批发明专利、中国驰名商标、国家生态原产地产品、国家地理标志证明商标，根据影响层级和品牌价值给予最高不超过 10 万元的一次性奖励。</p>
      <h4>提升文旅消费新业态扶持资金</h4>
      <p>对新评为国家五星级、四星级旅游饭店的，分别给予 100 万元、50 万元的一次性奖励。</p>
      <p>被评为国家五星级、四星级、三星级旅游民宿的，分别给予 30 万元、20 万、5 万元的一次性奖励；被评为四川省五星级农家乐、艺家乐、乡村酒店和成都市主题旅游客栈的，给予 5 万元的一次性奖励；被评为成都市 A、AA、AAA 级林盘景区的，分别给予 5 万元、15 万元、20 万元的一次性奖励；由低向高升级的，全额补足奖励级差部分。被评为成都市主题旅游目的地的，给予 5-20 万元的一次性奖励。</p>
      <p>励规范经营的农家乐、乡村酒店、民宿开展提档升级，对实施专业规划设计，并按照规划设计方案改造提升后达到乡村旅游“四改一提升”（改厨、改餐、改厕、改客房，提升服务水平）以及消防、环保、安全设施建设等标准的，按规划设计费的 50% 给予业主最高不超过 6 万元的补助。支持实体书店创新发展，探索多种经营模式，与文创、旅游、商贸、互联网等融合，成为集阅读学习、展示交流、创意生活等为一体的综合性、开放性文化体验消费空间，按当年租金的 50% 给予最高不超过 20 万元的一次性补助；对实体书店参与“书香成都”建设，开展各种引领文化风尚的全民阅读公益活动给予资金补助，补助金额为一项活动实际发生额的50%，年度最高不超过 10 万元。</p>
      <p>支持发展夜间文旅经济，开发定期运营的夜间剧场、音乐驿站，开展夜间专题演出、民俗风情表演活动（含非遗活态传承活动等），按照运营情况、接待游客数量、带动效益等，给予开发主体年度 5-10 万元补助。</p>
      <p>鼓励打造特色街区和夜间经济示范点，对主题旅游目的地、非遗文化体验点、文创旅游伴手礼商店、特色餐饮店、实体书店、博物馆等开展夜间延时服务并形成常态，按照运营情况、接待游客数量、带动效益等，给予年度 1-5 万元奖。</p>
      `, //弹窗文字内容，
    },
    projects: [
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "妙音湖生态度假酒",
        lianxifang: "蒲江县文体旅局产业科",
        phone: "88551569",
        img_count: 1,
        desc: `
        <h4 class="title">妙音湖生态度假酒</h4>
        <h4>建设地点</h4>
        <p>妙音湖周边地块</p>
        <h4>建设工期</h4>
        <p>3 年</p>
        <h4>投资总额</h4>
        <p>15 亿元</p>
        <h4>建设内容</h4>
        <p>依托妙音湖周边优势的自然资源建设座集休闲、度假、康养、茶文为一体的高端度假酒店集群。</p>
        <h4>建设条件</h4>
        <p>该区域是蒲江建设国际生态旅游度假区的核心区，区域内生态环境优良，动植物资源丰富，紧邻石象湖、成佳茶乡4A 级景区，交通便利，具有建设国际性度假酒店的基础。</p>
        <h4>合作方式</h4>
        <p>公司通过股买土地自建、自营。</p>
        <h4>联系方式</h4>
        <p>蒲江县文体旅局产业科 88551569</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "成佳七碗茶民宿",
        lianxifang: "蒲江县文体旅局产业科",
        phone: "88551569",
        img_count: 3,
        desc: `
        <h4 class="title">成佳七碗茶民宿</h4>
        <h4>建设地点</h4>
        <p>妙音湖周边地块</p>
        <h4>建设工期</h4>
        <p>3 年</p>
        <h4>投资总额</h4>
        <p>5.5 亿元</p>
        <h4>建设内容</h4>
        <p>依托妙音湖周边优势的自然资源建设座集休闲、度假、康养、茶文为一体的高端度假酒店集群。</p>
        <h4>建设条件</h4>
        <p>该区域是蒲江建设国际生态旅游度假区的核心区，区域内生态环境优良，动植物资源丰富，紧邻石象湖、成佳茶乡 4A 级景区，交通便利，具有建设国际性度假酒店的基础。</p>
        <h4>合作方式</h4>
        <p>公司通过股买土地自建、自营。</p>
        <h4>联系方式</h4>
        <p>蒲江县文体旅局产业科 88551569</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "森林度假酒店",
        lianxifang: "蒲江县文体旅局产业科",
        phone: "88551569",
        img_count: 1,
        desc: `
        <h4 class="title">森林度假酒店</h4>
        <h4>建设地点</h4>
        <p>妙音湖周边地块</p>
        <h4>建设工期</h4>
        <p>3 年</p>
        <h4>投资总额</h4>
        <p>5.5 亿元</p>
        <h4>建设内容</h4>
        <p>依托妙音湖周边优势的自然资源建设座集休闲、度假、康养、茶文为一体的高端度假酒店集群。</p>
        <h4>建设条件</h4>
        <p>该区域是蒲江建设国际生态旅游度假区的核心区，区域内生态环境优良，动植物资源丰富，紧邻石象湖、成佳茶乡 4A 级景区，交通便利，具有建设国际性度假酒店的基础。</p>
        <h4>合作方式</h4>
        <p>公司通过股买土地自建、自营。</p>
        <h4>联系方式</h4>
        <p>蒲江县文体旅局产业科 88551569</p>
        `,
      },
      {
        title_long: "2020年成都酒店业全球招商峰会活动<br>招商项目简介",
        title: "寿安铁路港酒店",
        lianxifang: "蒲江县文体旅局产业科",
        phone: "88551569",
        img_count: 1,
        desc: `
        <h4 class="title">寿安铁路港酒店</h4>
        <h4>建设地点</h4>
        <p>蒲江县寿安街道高铁新城</p>
        <h4>建设工期</h4>
        <p>5 年</p>
        <h4>投资总额</h4>
        <p>7 亿元</p>
        <h4>建设内容</h4>
        <p>依托川藏铁路第一港的人气建在寿安街道高铁新城内建设一座高星级的商务酒店，满足区域内高端商务、会议、论坛等活动要求。</p>
        <h4>建设条件</h4>
        <p>川藏铁路第一港是川藏铁路的保障中心，将在区域内建设与铁路建设相关的项目。</p>
        <h4>合作方式</h4>
        <p>公司通过股买土地自建、自营。</p>
        <h4>联系方式</h4>
        <p>蒲江县文体旅局产业科 88551569</p>
        `,
      },
    ],
  },
];
export default projects;
